<template>
  <div id="manage-intent" v-if="intent">
    <div>
      <v-layout wrap style="border-bottom: 1px solid #eee" class="mb-3" v-if="!isWelcome">
        <v-flex
          xs12
          sm5
          md6
          form-control
          :class="{ 'has-error': errors.has('intentName') }"
          class="px-2 pt-2"
        >
          <template v-if="!isBeacon">
            <input
              :disabled="
                ['111', '112', '113'].includes(selectedBot.selected_presets) &&
                  $store.state.presetIntentName.includes(intent.intentname)
              "
              type="text"
              v-if="!isDefault"
              class="form-control"
              :placeholder="isCommentToInbox ? $t('Comment Topic') : $t('Topic')"
              v-model="intent.intentname"
              name="intentName"
              :data-vv-as="$t('Conversation')"
              aria-describedby="Intent Name"
              v-validate="'required'"
              :data-vv-scope="intent.id"
            />
            <div v-else>
              <template v-if="intent.intentname == '{default_comment_to_inbox}'">
                <p>{{ $t('More Comment to Inbox') }}</p>
              </template>
              <template v-if="intent.intentname == '{first_announcement_message}'">
                <!-- <p>{{ $t('First Announcement') }}</p> -->
              </template>
              <template v-else>
                <p>{{ $t('Default Conversation') }}</p>
              </template>
            </div>
          </template>
          <template v-else>
            <input
              type="text"
              v-if="!isDefault"
              class="form-control"
              :placeholder="$t('Conversation')"
              v-model="intent.campaign_name"
              name="intentName"
              :data-vv-as="$t('Conversation')"
              aria-describedby="Intent Name"
              v-validate="
                'required|excludednew:{default},{welcome}' +
                  (excludedName ? ',' + excludedName : '')
              "
            />
          </template>
          <span class="text-error" v-show="errors.has('intentName')">{{
            errors.first('intentName')
          }}</span>
        </v-flex>
        <v-flex xs12 sm7 md6 class="px-2 pt-2">
          <slot name="action"></slot>
          <div v-if="showReplyCommentSelectPost" class="text-xs-right">
            <template>
              <v-btn color="primary" small outline @click="showSelectPost = true">
                <IntentSelectPostLabel :value="postidlist"></IntentSelectPostLabel>

                <v-icon small>edit</v-icon>
              </v-btn>

              <intent-select-post
                :includePost="intent.postidlist"
                :excludePost="intent.exceptpostidlist"
                :post_keywords="intent.post_keywords"
                :show="showSelectPost"
                :useexclude="true"
                @save="saveFilterPost"
                @close="showSelectPost = false"
              ></intent-select-post>
            </template>
            <!--
            <v-btn color="grey" disabled v-else outline>
              <IntentSelectPostLabel :value="postidlist"></IntentSelectPostLabel>
              <v-icon class="ml-1">edit</v-icon>
              <v-premium-lock></v-premium-lock>
            </v-btn> -->
          </div>
          <template v-if="isBeacon">
            <div class="text-xs-right">
              <v-btn
                color="primary"
                small
                :outline="!intent.specific_beacon_ids"
                @click="showSelectBeacon = true"
              >
                {{
                  intent.specific_beacon_ids
                    ? `เลือก Beacon ${countBeaconID(intent.specific_beacon_ids)}`
                    : 'เลือก Beacon (ทั้งหมด)'
                }}
              </v-btn>
            </div>
            <intent-select-beacon
              v-if="showSelectBeacon"
              v-model="intent.specific_beacon_ids"
              :showSelectBeacon="showSelectBeacon"
              @closeShowSelectBeacon="closeShowSelectBeacon()"
            >
            </intent-select-beacon>
          </template>
        </v-flex>
        <v-flex xs12 class="px-2 pt-1 pb-2" align-end v-if="!isLivechat">
          <v-layout>
            <v-flex class="text-xs-left">
              <toggle-button
                v-if="!isBeacon"
                :value="intent.intentstatus"
                :sync="true"
                :color="$vuetify.theme.success"
                @change="onChangeIntentStatus"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
              />
              <span class="mr-2">{{
                intent.intentname === '{first_announcement_message}'
                  ? $t('First Announcement')
                  : isCommentToInbox
                  ? $t('Turn On/Off Reply Comment')
                  : $t('Turn On/Off Conversation')
              }}</span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm6 class="pa-1 pl-2 pr-2" v-if="!isLivechat">
          <template v-if="!isDefault">
            <intent-question
              ref="form"
              :isCommentToInbox="isCommentToInbox"
              :isWelcome="isWelcome"
              :isBeacon="isBeacon"
              :isEventPurchase="Boolean(intent.event_setting && intent.event_setting.event_name)"
              v-model="intent.q_val"
              @onClickVerifySlip="onClickVerifySlip"
              @onClickClearVerifySlip="onClickClearVerifySlip"
            ></intent-question>
          </template>
          <template v-else>
            <p class="small" style="margin-bottom: 0px">
              <template v-if="intent.intentname == '{default}'"></template>
              <template v-else-if="intent.intentname == '{default_comment_to_inbox}'"></template>
            </p>
          </template>
        </v-flex>
        <v-flex class="pa-1" :class="isLivechat ? 'xs12' : 'xs12 sm6'">
          <!-- <div class="hr show-on-small hide-on-med-and-up" style="margin: 15px -15px"></div> -->
          <template v-if="(isReplyComment && isCommentToInbox) || isLiveStream">
            <intent-comment
              :isLiveStream="isLiveStream"
              v-model="messages"
              :intentname="intent.intentname"
              :intent="intent"
            ></intent-comment>
          </template>
          <template v-else-if="isWelcome && !showMultipleChannel">
            <slot name="welcome" v-bind="{ showMultipleChannel, changeSetting }"></slot>
          </template>
          <template v-else>
            <v-layout>
              <v-flex
                v-if="showMultipleChannel"
                class="channel"
                shrink
                style="border-right: 1px solid #eee"
              >
                <template v-for="(item, index) in channels">
                  <div
                    :key="index"
                    :class="{ 'primary white--text': tab == item.name, disabled: item.disabled }"
                    @click="onChangeChannel(item)"
                    class="tab-channel"
                  >
                    <div class="lock" v-if="item.disabled">
                      <v-premium-lock2
                        type="advanced"
                        text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                      ></v-premium-lock2>
                    </div>
                    <span :class="`fab ${item.icon}`"></span>
                    <!-- <vue-simple-svg v-else
                    :style="tab == 'google' ? 'fill: #ffffff' : 'fill: #969595'"
                    style="fill: #969595;"
                    :filepath="'/static/img/assets/logo/business-messages-icon.svg'"
                    class="img"
                  /> -->
                  </div>
                </template>
              </v-flex>
              <v-flex style="overflow: auto" :key="timestamp">
                <template v-if="intent.intentname === '{first_announcement_message}'">
                  <span>
                    {{ $t(`Turn On/Off Date & Time Setting for Bot's Reply`) }}
                  </span>
                  <v-flex class="mt-2">
                    <div class="form-control">
                      <div class="caption">{{ $t('Turn-on Time') }}</div>
                      <v-layout wrap>
                        <v-flex
                          xs6
                          class="form-control"
                          :class="{ 'has-error': errors.has('startdate') }"
                        >
                          <v-menu
                            ref="openStartDate"
                            v-model="openStartDate"
                            :close-on-content-click="false"
                            full-width
                            max-width="290px"
                            color="primary"
                          >
                            <template v-slot:activator="{ on }">
                              <input
                                type="text"
                                class="form-control browser-default"
                                :placeholder="$t('Date')"
                                readonly
                                v-model="startDate"
                                v-on="on"
                                clearable
                              />
                            </template>
                            <v-date-picker
                              color="primary"
                              v-model="startDate"
                              @input="handleStartdate()"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs4 class="pl-1">
                          <time-picker-custom
                            v-model="startTimeInput"
                            max="23:59"
                            :disabled="startDate === null"
                            @input="handleStartTime()"
                          >
                          </time-picker-custom>
                          <!-- <time-picker
                            v-model="startTime"
                            :key="`setstarttime_${timestamp}`"
                            full-width
                            :disabled="startDate == null"
                            :placeholder="$t('Time')"
                            :hide-clear-button="true"
                          ></time-picker> -->
                        </v-flex>
                        <v-flex xs2>
                          <v-btn
                            fab
                            flat
                            small
                            color="primary"
                            style="height: 35px; width: 35px"
                            @click="
                              startDate = null
                              startTime = null
                              changeTimestamp()
                            "
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                  <v-flex>
                    <div class="form-control">
                      <div class="caption">{{ $t('Turn-off Time') }}</div>
                      <v-layout wrap>
                        <v-flex
                          class="form-control"
                          xs6
                          :class="{ 'has-error': errors.has('enddate') }"
                        >
                          <v-menu
                            ref="openEndDate"
                            v-model="openEndDate"
                            :close-on-content-click="false"
                            full-width
                            max-width="290px"
                            color="primary"
                          >
                            <template v-slot:activator="{ on }">
                              <input
                                type="text"
                                class="form-control browser-default"
                                :placeholder="$t('Date')"
                                readonly
                                v-model="endDate"
                                v-on="on"
                                clearable
                              />
                            </template>
                            <v-date-picker
                              color="primary"
                              v-model="endDate"
                              @input="handleEndDate()"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs4 class="pl-1">
                          <time-picker-custom
                            v-model="endTimeInput"
                            :disabled="endDate === null"
                            @input="handleEndTime()"
                          >
                          </time-picker-custom>
                          <!-- <time-picker
                            :key="`setendtime_${timestamp}`"
                            v-model="endTime"
                            :disabled="endDate == null"
                            full-width
                            format="HH:mm"
                            :placeholder="$t('Time')"
                            :hide-clear-button="true"
                          ></time-picker> -->
                          <!-- <v-menu
                                ref="openEndTime"
                                v-model="openEndTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="endTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                                :disabled="endDate == null"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="endTime"
                                    v-on="on"
                                    :disabled="endDate == null"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openEndTime"
                                  v-model="endTime"
                                  full-width
                                  @click:minute="$refs.openEndTime.save(endTime)"
                                ></v-time-picker>
                              </v-menu> -->
                        </v-flex>
                        <v-flex xs2>
                          <v-btn
                            fab
                            flat
                            small
                            color="primary"
                            style="height: 35px; width: 35px"
                            @click="
                              endDate = null
                              endTime = null
                              changeTimestamp()
                            "
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>

                  <intent-group
                    v-model="messages"
                    @clearToWayVerify="clearToWayVerify"
                    :intentname="intent.intentname"
                    :channel="tab"
                    @changeSetting="changeSetting"
                    :isFirstAnnouncement="intent.intentname === '{first_announcement_message}'"
                  ></intent-group>
                </template>
                <template v-else-if="!showMultipleChannel">
                  <intent-group
                    @clearToWayVerify="clearToWayVerify"
                    :isIntent="isIntent"
                    v-model="messages"
                    :intentname="intent.intentname"
                    :showMultipleChannel="showMultipleChannel"
                    :channel="tab"
                    :isVerifySlip="isVerifySlip"
                    :correct.sync="messages_correct"
                    :incorrect.sync="messages_incorrect"
                    :err.sync="messages_error"
                    :duplicate.sync="messages_duplicate"
                    @changeSetting="changeSetting"
                    :isBeacon="isBeacon"
                    ref="intentGroup"
                  ></intent-group>
                </template>
                <template v-else>
                  <template v-if="tab == 'facebook'">
                    <keep-alive>
                      <intent-group
                        @clearToWayVerify="clearToWayVerify"
                        :isIntent="isIntent"
                        key="fb_message"
                        v-model="fb_messages"
                        :intentname="intent.intentname"
                        :showMultipleChannel="showMultipleChannel"
                        :channel="tab"
                        :isVerifySlip="isVerifySlip"
                        :correct.sync="fb_messages_correct"
                        :incorrect.sync="fb_messages_incorrect"
                        :err.sync="fb_messages_error"
                        :duplicate.sync="fb_messages_duplicate"
                        @changeSetting="changeSetting"
                        ref="intentGroup"
                      ></intent-group>
                    </keep-alive>
                  </template>
                  <template v-else-if="tab == 'line'">
                    <keep-alive>
                      <intent-group
                        @clearToWayVerify="clearToWayVerify"
                        :isIntent="isIntent"
                        key="line_message"
                        v-model="line_messages"
                        :intentname="intent.intentname"
                        :showMultipleChannel="showMultipleChannel"
                        :isVerifySlip="isVerifySlip"
                        :correct.sync="line_messages_correct"
                        :incorrect.sync="line_messages_incorrect"
                        :err.sync="line_messages_error"
                        :duplicate.sync="line_messages_duplicate"
                        @changeSetting="changeSetting"
                        :channel="tab"
                        ref="intentGroup"
                      ></intent-group>
                    </keep-alive>
                  </template>
                  <template v-else-if="tab == 'instagram'">
                    <keep-alive>
                      <intent-group
                        @clearToWayVerify="clearToWayVerify"
                        :isIntent="isIntent"
                        key="ig_message"
                        v-model="ig_messages"
                        :intentname="intent.intentname"
                        :showMultipleChannel="showMultipleChannel"
                        :isVerifySlip="isVerifySlip"
                        :correct.sync="ig_messages_correct"
                        :incorrect.sync="ig_messages_incorrect"
                        :err.sync="ig_messages_error"
                        :duplicate.sync="ig_messages_duplicate"
                        @changeSetting="changeSetting"
                        :channel="tab"
                        ref="intentGroup"
                      ></intent-group>
                    </keep-alive>
                  </template>
                  <template v-else-if="tab == 'google'">
                    <keep-alive>
                      <intent-group
                        @clearToWayVerify="clearToWayVerify"
                        :isIntent="isIntent"
                        key="google_message"
                        v-model="google_messages"
                        :intentname="intent.intentname"
                        :showMultipleChannel="showMultipleChannel"
                        :isVerifySlip="isVerifySlip"
                        :correct.sync="google_messages_correct"
                        :incorrect.sync="google_messages_incorrect"
                        :err.sync="google_messages_error"
                        :duplicate.sync="google_messages_duplicate"
                        @changeSetting="changeSetting"
                        :channel="tab"
                        ref="intentGroup"
                      ></intent-group>
                    </keep-alive>
                  </template>
                  <template v-else-if="tab == 'whatsapp'">
                    <keep-alive>
                      <intent-group
                        @clearToWayVerify="clearToWayVerify"
                        :isIntent="isIntent"
                        key="whatsapp_message"
                        v-model="whatsapp_messages"
                        :intentname="intent.intentname"
                        :showMultipleChannel="showMultipleChannel"
                        :isVerifySlip="isVerifySlip"
                        :correct.sync="whatsapp_messages_correct"
                        :incorrect.sync="whatsapp_messages_incorrect"
                        :err.sync="whatsapp_messages_error"
                        :duplicate.sync="whatsapp_messages_duplicate"
                        @changeSetting="changeSetting"
                        :channel="tab"
                        ref="intentGroup"
                      ></intent-group>
                    </keep-alive>
                  </template>
                </template>

                <template
                  v-if="
                    !isWelcome &&
                      !isCommentToInbox & (tab !== 'whatsapp') &&
                      intent.intentname !== '{first_announcement_message}'
                  "
                >
                  <div class="hr"></div>
                  <div class="small" style="margin-top: 10px">{{ $t('Choice') }}</div>

                  <div
                    class="caption grey--text"
                    v-if="selectedBot.instagram_business_account && !isBeacon"
                  >
                    * {{ $t('Not available if using with Button/List Menu') }}
                  </div>
                  <div
                    class="caption grey--text"
                    v-if="selectedBot.packages.includes('whatsapp') && !isBeacon"
                  >
                    * {{ $t('Quick messages cannot be used on the WhatsApp platform.') }}
                  </div>
                  <div class="mb-3"></div>

                  <template v-if="!showMultipleChannel">
                    <div
                      class="form-control"
                      :class="{ 'has-error': errorTag['replies'].length > 0 }"
                    >
                      <tags
                        v-model="reply"
                        :tags="replies"
                        @tags-changed="addReplies('replies', $event)"
                        @before-adding-tag="checkQuickReply('replies', $event)"
                        style="margin-bottom: 5px"
                        :btnText="$t('Add choice')"
                      ></tags>
                    </div>
                  </template>
                  <template v-else>
                    <div class="form-control" :class="{ 'has-error': errorTag[tab].length > 0 }">
                      <tags
                        v-model="reply"
                        :tags="
                          tab == 'facebook'
                            ? fb_replies
                            : tab == 'line'
                            ? line_replies
                            : tab === 'whatsapp'
                            ? whatsapp_replies
                            : tab === 'google'
                            ? google_replies
                            : ig_replies
                        "
                        @tags-changed="addReplies(tab, $event)"
                        @before-adding-tag="checkQuickReply(tab, $event)"
                        style="margin-bottom: 5px"
                        :btnText="$t('Add choice')"
                      ></tags>
                    </div>
                  </template>
                  <!-- <template v-if="isBeacon">
                    <div style="margin-top: 10px">
                      {{ $t('จำนวนครั้งที่ส่งข้อความสูงสุดต่อวัน') }}
                    </div>
                    <div class="form-control">
                      <input
                        type="number"
                        class="form-control"
                        v-model="intent.frequency_per_day"
                        maxlength="10"
                      />
                    </div>
                  </template> -->
                  <div class="form-control has-error">
                    <template v-for="(error, errorKey) in errorTag">
                      <span :key="errorKey" class="text-error" v-if="error.length > 0">
                        <template v-if="error.includes('overmaxlength')">{{
                          $t('Message cannot be longer than 20 alphabets')
                        }}</template>
                        <template v-else-if="error.includes('overtagmax')">{{
                          $t('Choices cannot be more than 10 items')
                        }}</template>
                        <template v-else-if="error.includes('duplicate')">{{
                          $t('Duplicate Choice')
                        }}</template>
                      </span>
                    </template>
                  </div>
                </template>
                <template v-else>
                  <div class="mb-3"></div>
                </template>
              </v-flex>
            </v-layout>
          </template>
        </v-flex>
      </v-layout>

      <div class="mt-4">
        <div class="hr"></div>
        <div class="text-xs-center" style="margin: -13px">
          <a
            class="text btn-advanced"
            href="javascript:void(0);"
            @click="onShowAdvance"
            style="position: relative"
          >
            {{ $t('Advanced') }}
            <i
              class="fa"
              :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }"
            ></i>
            <!-- <v-premium-lock :inline="true"></v-premium-lock> -->
          </a>
        </div>

        <template>
          <div
            style="margin-top: 25px"
            v-show="showAdvanced || errors.has('context_in') || errors.has('startdate')"
          >
            <v-tabs v-model="advancedTab" slider-color="primary" touchless show-arrows>
              <v-tab key="customer" href="#customer" ripple
                >{{ $t('Customer') }}
                <a @click="openLink('https://tinyurl.com/2rs9ahu7')"
                  ><i
                    style="font-size: 18px; color: #ed1e79;"
                    class="ml-1 fas fa-question-circle"
                  ></i></a
              ></v-tab>
              <template v-if="intent.intentname !== '{first_announcement_message}'">
                <v-tab
                  v-if="!isCommentToInbox && !isLiveStream && !isBeacon"
                  key="context"
                  href="#context"
                  ripple
                  >{{ $t('Context') }}
                  <a @click="openLink('https://tinyurl.com/3pbbzz54')"
                    ><i
                      style="font-size: 18px; color: #ed1e79;"
                      class="ml-1 fas fa-question-circle"
                    ></i></a
                ></v-tab>
                <v-tab
                  v-if="!isLivechat && !livechatapp && !isBeacon"
                  key="timer"
                  href="#timer"
                  ripple
                  >{{ $t('Timer') }}
                  <a @click="openLink('https://tinyurl.com/2556a5py')"
                    ><i
                      style="font-size: 18px; color: #ed1e79;"
                      class="ml-1 fas fa-question-circle"
                    ></i></a
                ></v-tab>
                <v-tab v-if="!livechatapp && !isBeacon" key="line_notify" href="#line_notify" ripple
                  >{{ $t('Line Notify') }}
                  <a @click="openLink('https://tinyurl.com/2p82ydvv')"
                    ><i
                      style="font-size: 18px; color: #ed1e79;"
                      class="ml-1 fas fa-question-circle"
                    ></i></a
                ></v-tab>
                <v-tab
                  key="limit_reply_to_inbox"
                  href="#limit_reply_to_inbox"
                  v-if="
                    isCommentToInbox &&
                      !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname) &&
                      !isLivechat &&
                      !isBeacon
                  "
                  ripple
                  >{{ $t('Limit reply to inbox') }}
                  <a
                    @click="
                      openLink(
                        'https://blog.zwiz.ai/%E0%B8%AA%E0%B8%B9%E0%B8%95%E0%B8%A3%E0%B8%A5%E0%B8%B1%E0%B8%9A%E0%B9%81%E0%B8%8A%E0%B8%97%E0%B8%9A%E0%B8%AD%E0%B8%97-004/'
                      )
                    "
                    ><i
                      style="font-size: 18px; color: #ed1e79;"
                      class="ml-1 fas fa-question-circle"
                    ></i></a
                ></v-tab>
                <v-tab v-if="!livechatapp && !isBeacon" key="priority" href="#priority" ripple
                  >{{ $t('priority') }}
                  <a @click="openLink('https://blog.zwiz.app/priorityfeature/')"
                    ><i
                      style="font-size: 18px; color: #ed1e79;"
                      class="ml-1 fas fa-question-circle"
                    ></i
                  ></a>
                </v-tab>
                <v-tab v-if="isBeacon" key="frequency" href="#frequency" ripple>{{
                  $t('frequency')
                }}</v-tab>
                <v-tab
                  v-if="
                    !livechatapp &&
                      !isBeacon &&
                      !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname)
                  "
                  key="followUp"
                  href="#followUp"
                  ripple
                  >{{ $t('Follow Up') }}
                  <a @click="openLink('https://tinyurl.com/5banvvcf')"
                    ><i
                      style="font-size: 18px; color: #ed1e79;"
                      class="ml-1 fas fa-question-circle"
                    ></i></a
                ></v-tab>
                <v-tab
                  v-if="
                    !livechatapp &&
                      !isBeacon &&
                      !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname)
                  "
                  key="purchase_event"
                  href="#purchase_event"
                  ripple
                >
                  {{ $t('purchase_event') }}
                  <a
                    @click="openLink('https://blog.zwiz.app/สูตรลับ-23-วิธีเช็ค-conversion-รู้ทั/')"
                    ><i
                      style="font-size: 18px; color: #ed1e79;"
                      class="ml-1 fas fa-question-circle"
                    ></i
                  ></a>
                </v-tab>
              </template>
            </v-tabs>
            <v-tab-item v-show="advancedTab === 'customer'">
              <v-card
                flat
                :style="{
                  'min-height': $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                ></v-premium-plan-popup>
                <v-card-text>
                  <div class="form-control mb-2">
                    <div class="primary--text caption">{{ $t('Status') }}</div>
                    <!-- <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('Status')"
                        v-model="intent.userstatus"
                        maxlength="600"
                      /> -->
                    <v-layout wrap>
                      <v-flex sm11>
                        <multiselect
                          :options="statusOptions"
                          v-model="intent.userstatus"
                          :multiple="false"
                          :taggable="true"
                          @input="errorMaxlength = false"
                          @tag="onSelectStatus"
                        >
                        </multiselect>
                        <small style="color:red" v-if="errorMaxlength">
                          {{ $t('message_cannot_be_longer_than_25_alphabets') }}</small
                        >
                      </v-flex>
                      <v-flex sm1>
                        <v-btn samll icon @click="intent.userstatus = null">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                  <div>
                    <div class="primary--text caption mb-1">{{ $t('Tag') }}</div>
                    <tags
                      :combobox="true"
                      v-model="usertag"
                      :key="`tagOptions_${timestamp}`"
                      :tags="usertags"
                      @tags-changed="addUserTags"
                      @before-adding-tag="checkUserTags"
                      :itemOption="tagOptions"
                      style="margin-bottom: 5px"
                      :btnText="$t('Add tag')"
                    ></tags>

                    <small style="color:red" v-if="errorMaxlengthTags">
                      {{ $t('message_cannot_be_longer_than_25_alphabets') }}</small
                    >
                    <!-- <div class="caption">
                        {{ $t('Learn more') }}
                        <a
                          href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%95%e0%b8%b4%e0%b8%94%e0%b8%aa%e0%b8%96%e0%b8%b2%e0%b8%99%e0%b8%b0status-%e0%b8%9b%e0%b9%89%e0%b8%b2%e0%b8%a2%e0%b8%81%e0%b8%b3%e0%b8%81%e0%b8%b1%e0%b8%9atag/"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ $t('click here') }}</a
                        >
                      </div> -->
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              v-if="!isCommentToInbox && !isLiveStream && !isBeacon"
              v-show="advancedTab === 'context'"
            >
              <v-card
                flat
                :style="{
                  'min-height': $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                ></v-premium-plan-popup>
                <v-card-text>
                  <v-layout>
                    <v-flex
                      xs6
                      class="form-control pr-1"
                      :class="{ 'has-error': errors.has('context_in') }"
                    >
                      <template v-if="isLiveStream">
                        <input
                          type="text"
                          class="form-control"
                          :value="$t('facebooklive')"
                          readonly
                          disabled
                        />
                      </template>
                      <template v-else-if="isCommentToInbox">
                        <input
                          type="text"
                          class="form-control"
                          :value="$t('Comment')"
                          readonly
                          disabled
                        />
                      </template>
                      <template v-else>
                        <multi-select-custom
                          v-model="intent.context_in"
                          :options.sync="contextOptions"
                          label="label"
                          trackBy="value"
                          name="context_in"
                          placeholder="Context In"
                          :taggable="true"
                          @tag="intent.context_in = $event"
                        >
                        </multi-select-custom>
                        <span class="text-error" v-show="errors.has('context_in')">
                          {{ $t('Context In cannot be Comment') }}
                        </span>
                        <!-- <input
                          style="margin-bottom: 5px"
                          type="text"
                          class="form-control"
                          placeholder="Context In"
                          data-vv-as="Context In"
                          v-model="intent.context_in"
                        /> -->
                      </template>
                    </v-flex>
                    <v-flex class="form-control pl-1">
                      <multi-select-custom
                        v-model="intent.context_out"
                        :options.sync="contextOptions"
                        label="label"
                        trackBy="value"
                        placeholder="Context Out"
                        :taggable="true"
                        @tag="intent.context_out = $event"
                      >
                      </multi-select-custom>
                      <!-- <input
                        type="text"
                        class="form-control"
                        placeholder="Context Out"
                        v-model="intent.context_out"
                      /> -->
                    </v-flex>
                  </v-layout>
                  <!-- <div class="caption">
                      {{ $t('Learn more') }}
                      <a
                        href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b9%83%e0%b8%8a%e0%b9%89-context/"
                        target="_blank"
                        rel="noopener noreferrer"
                        >{{ $t('click here') }}</a
                      >
                    </div> -->
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!isLivechat && !isBeacon" v-show="advancedTab === 'timer'">
              <v-card
                flat
                :style="{
                  'min-height': $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                ></v-premium-plan-popup>
                <v-card-text v-if="intent.intentname !== '{first_announcement_message}'">
                  <v-radio-group @change="changeOnlytime" v-model="intent.onlytime">
                    <v-radio
                      :color="'primary'"
                      :label="$t(`Turn On/Off Date & Time Setting for Bot's Reply`)"
                      :value="false"
                    ></v-radio>
                    <v-radio
                      :color="'primary'"
                      :label="$t(`Selecting certain chatbot's answers for the certain time`)"
                      :value="true"
                    ></v-radio>
                    <v-radio
                      :color="'primary'"
                      :label="$t(`Select by date and time`)"
                      :value="null"
                      v-if="hasTypeDateAndTime"
                    ></v-radio>
                  </v-radio-group>
                  <v-layout v-if="intent.onlytime">
                    <v-flex class="pr-1">
                      <div class="form-control">
                        <div class="caption">{{ $t('Turn-on Time') }}</div>
                        <v-layout wrap>
                          <v-flex xs10 class="pl-1">
                            <time-picker-custom v-model="startTimeInput" max="23:59">
                            </time-picker-custom>
                            <!-- <time-picker
                              v-model="startTime"
                              :key="`setstarttime_${timestamp}`"
                              full-width
                              format="HH:mm"
                              :placeholder="$t('Time')"
                              :hide-clear-button="true"
                            ></time-picker> -->
                            <!-- <v-menu
                                ref="openStartTime"
                                v-model="openStartTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="startTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="startTime"
                                    v-on="on"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openStartTime"
                                  v-model="startTime"
                                  full-width
                                  @click:minute="$refs.openStartTime.save(startTime)"
                                ></v-time-picker>
                              </v-menu> -->
                          </v-flex>
                          <v-flex xs2>
                            <v-btn
                              fab
                              flat
                              small
                              color="primary"
                              style="height: 35px; width: 35px"
                              @click="
                                startDate = null
                                startTime = null
                                changeTimestamp()
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                    <v-flex class="pl-1">
                      <div class="form-control">
                        <div class="caption">{{ $t('Turn-off Time') }}</div>
                        <v-layout wrap>
                          <v-flex xs10 class="pl-1">
                            <time-picker-custom v-model="endTimeInput"> </time-picker-custom>
                            <!-- <time-picker
                              v-model="endTime"
                              :key="`setendtime_${timestamp}`"
                              full-width
                              format="HH:mm"
                              :placeholder="$t('Time')"
                              :hide-clear-button="true"
                            ></time-picker> -->
                            <!-- <v-menu
                                ref="openEndTime"
                                v-model="openEndTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="endTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="endTime"
                                    v-on="on"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openEndTime"
                                  v-model="endTime"
                                  full-width
                                  @click:minute="$refs.openEndTime.save(endTime)"
                                ></v-time-picker>
                              </v-menu> -->
                          </v-flex>
                          <v-flex xs2>
                            <v-btn
                              fab
                              flat
                              small
                              color="primary"
                              style="height: 35px; width: 35px"
                              @click="
                                endDate = null
                                endTime = null
                                changeTimestamp()
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout v-else-if="intent.onlytime === false">
                    <v-flex class="pr-1 mt-2">
                      <div class="form-control">
                        <div class="caption">{{ $t('Turn-on Time') }}</div>
                        <v-layout wrap>
                          <v-flex
                            xs6
                            class="form-control"
                            :class="{ 'has-error': errors.has('startdate') }"
                          >
                            <v-menu
                              ref="openStartDate"
                              v-model="openStartDate"
                              :close-on-content-click="false"
                              full-width
                              max-width="290px"
                              color="primary"
                            >
                              <template v-slot:activator="{ on }">
                                <input
                                  type="text"
                                  class="form-control browser-default"
                                  :placeholder="$t('Date')"
                                  readonly
                                  v-model="startDate"
                                  v-on="on"
                                  clearable
                                />
                              </template>
                              <v-date-picker
                                color="primary"
                                v-model="startDate"
                                @input="handleStartdate()"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs4 class="pl-1">
                            <time-picker-custom
                              v-model="startTimeInput"
                              max="23:59"
                              :disabled="startDate === null"
                              @input="handleStartTime()"
                            >
                            </time-picker-custom>
                            <!-- <v-menu
                                ref="openStartTime"
                                v-model="openStartTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="startTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                                :disabled="startDate == null"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="startTime"
                                    v-on="on"
                                    :disabled="startDate == null"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openStartTime"
                                  v-model="startTime"
                                  full-width
                                  @click:minute="$refs.openStartTime.save(startTime)"
                                ></v-time-picker>
                              </v-menu> -->
                          </v-flex>
                          <v-flex xs2>
                            <v-btn
                              fab
                              flat
                              small
                              color="primary"
                              style="height: 35px; width: 35px"
                              @click="
                                startDate = null
                                startTime = null
                                changeTimestamp()
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                    <v-flex class="pl-1 mt-2">
                      <div class="form-control">
                        <div class="caption">{{ $t('Turn-off Time') }}</div>
                        <v-layout wrap>
                          <v-flex
                            class="form-control"
                            xs6
                            :class="{ 'has-error': errors.has('enddate') }"
                          >
                            <v-menu
                              ref="openEndDate"
                              v-model="openEndDate"
                              :close-on-content-click="false"
                              full-width
                              max-width="290px"
                              color="primary"
                            >
                              <template v-slot:activator="{ on }">
                                <input
                                  type="text"
                                  class="form-control browser-default"
                                  :placeholder="$t('Date')"
                                  readonly
                                  v-model="endDate"
                                  v-on="on"
                                  clearable
                                />
                              </template>
                              <v-date-picker
                                color="primary"
                                v-model="endDate"
                                @input="handleEndDate()"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs4 class="pl-1">
                            <time-picker-custom
                              v-model="endTimeInput"
                              @input="handleEndTime()"
                              :disabled="endDate === null"
                            >
                            </time-picker-custom>
                            <!-- <time-picker
                              :key="`setendtime_${timestamp}`"
                              v-model="endTime"
                              full-width
                              format="HH:mm"
                              :placeholder="$t('Time')"
                              :hide-clear-button="true"
                            ></time-picker> -->
                            <!-- <v-menu
                                ref="openEndTime"
                                v-model="openEndTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="endTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                                :disabled="endDate == null"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="endTime"
                                    v-on="on"
                                    :disabled="endDate == null"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openEndTime"
                                  v-model="endTime"
                                  full-width
                                  @click:minute="$refs.openEndTime.save(endTime)"
                                ></v-time-picker>
                              </v-menu> -->
                          </v-flex>
                          <v-flex xs2>
                            <v-btn
                              fab
                              flat
                              small
                              color="primary"
                              style="height: 35px; width: 35px"
                              @click="
                                endDate = null
                                endTime = null
                                changeTimestamp()
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    v-else-if="
                      hasTypeDateAndTime && intent.onlytime === null && intent.time_setting
                    "
                  >
                    <v-flex>
                      <v-card class="mt-2 pa-3">
                        <div class="pa-2 hidden-xs-only">
                          <v-layout wrap>
                            <v-flex xs4 class="text-xs-center strong">{{ $t('Date_1') }}</v-flex>
                            <v-flex xs4 class="text-xs-center strong">{{ $t('Open at') }}</v-flex>
                            <v-flex xs4 class="text-xs-center strong">{{ $t('Close at') }}</v-flex>
                          </v-layout>
                        </div>
                        <v-divider></v-divider>
                        <template v-for="(time, key) in intent.time_setting">
                          <open-time-bot-item
                            :key="key"
                            v-model="intent.time_setting[key]"
                            :name="key"
                            :isEdit="true"
                          ></open-time-bot-item>
                        </template>
                      </v-card>
                    </v-flex>
                  </v-layout>

                  <div class="form-control" :class="{ 'has-error': errors.has('startdate') }">
                    <input
                      v-model="startTimeFormat"
                      type="hidden"
                      :data-vv-as="$t('Start date')"
                      name="startdate"
                      v-validate="endTimeFormat ? '' : ''"
                    />
                    <input
                      :data-vv-as="$t('End date')"
                      name="enddate"
                      v-model="endTimeFormat"
                      type="hidden"
                      ref="beforeTarget"
                    />

                    <span class="text-error" v-if="errors.has('startdate')">{{
                      errors.first('startdate')
                    }}</span>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!isBeacon" v-show="advancedTab === 'line_notify'">
              <v-card
                flat
                :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '250px' : '' }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium'"
                ></v-premium-plan-popup>
                <v-card-text>
                  <div class="primary--text">
                    {{ $t('Line Notify') }}
                  </div>
                  <v-layout>
                    <v-flex xs8 class="pt-3">
                      {{ $t('Turn on/off Line Notify') }}
                    </v-flex>
                    <v-flex xs4 class="text-xs-right">
                      <template v-if="$store.state.linenotifylist.length == 0"></template>
                      <template
                        v-else-if="
                          (selectedBot.notify_intent && !isCommentToInbox) ||
                            (selectedBot.notify_comment && isCommentToInbox)
                        "
                      >
                        <toggle-button
                          class="mt-2"
                          :value="intent.linenoti_status"
                          :sync="true"
                          :color="$vuetify.theme.success"
                          @change="toggleLineNotifyStatus"
                          :labels="{ checked: 'ON', unchecked: 'OFF' }"
                          style="display: inline-block"
                        />
                      </template>
                    </v-flex>
                  </v-layout>
                  <div class="col s12">
                    <template v-if="$store.state.linenotifylist.length == 0">
                      {{ $t('You are not connected to Line Notify.') }}
                      <router-link to="billing">{{
                        $t('Click to connected Line Notify at the settings page')
                      }}</router-link>
                    </template>
                    <template
                      v-else-if="
                        (selectedBot.notify_intent && !isCommentToInbox) ||
                          (selectedBot.notify_comment && isCommentToInbox)
                      "
                    >
                      <div class="form-control">
                        <textarea
                          class="form-control"
                          :placeholder="$t('Message')"
                          maxlength="2000"
                          v-model="intent.linenoti_text"
                        ></textarea>
                      </div>

                      <!-- Select line notify -->
                      <div>{{ $t('Select Line Account') }}</div>
                      <v-combobox
                        style="z-index: 0;"
                        v-model="selectLinenotify"
                        :items="$store.state.linenotifylist"
                        :item-text="'name'"
                        :item-value="'id'"
                        multiple
                        chips
                        outline
                        single-line
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            :key="JSON.stringify(data.item)"
                            :selected="data.selected"
                            :disabled="data.disabled"
                            class="v-chip--select-multi"
                            @input="data.parent.selectItem(data.item.adminid)"
                          >
                            <v-avatar>
                              <v-img
                                :src="
                                  `https://graph.facebook.com/${data.item.adminid}/picture?type=square&SameSite=None` ||
                                    data.item.line_picture_url
                                "
                                @error="onFailLoad"
                              ></v-img>
                            </v-avatar>
                            {{ data.item.name }}
                          </v-chip>
                        </template>
                      </v-combobox>
                    </template>
                    <template v-else>
                      {{ $t('Not yet alert via Line Notify.') }}
                      <router-link to="billing">{{
                        $t('Click to connected Line Notify at the settings page')
                      }}</router-link>
                    </template>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              v-show="advancedTab === 'limit_reply_to_inbox'"
              v-if="
                isCommentToInbox &&
                  !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname) &&
                  !isBeacon
              "
            >
              <v-card
                flat
                :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '250px' : '' }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium'"
                ></v-premium-plan-popup>
                <v-card-text>
                  <div class="col s12 form-control">
                    <v-checkbox
                      v-model="isremainingreply"
                      color="primary"
                      :label="$t('Reply to comment (amount)')"
                      hide-details
                      @change="changeRemainingReply"
                    ></v-checkbox>
                    <input
                      type="number"
                      class="mt-2"
                      v-model="remaining_reply"
                      :disabled="!isremainingreply"
                      :placeholder="$t('Amount2')"
                    />
                    <v-checkbox
                      v-model="notreplysameperson"
                      color="primary"
                      :label="$t('Reply once/person')"
                      hide-details
                    ></v-checkbox>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              v-if="!isBeacon && advancedTab === 'priority'"
              v-show="advancedTab === 'priority'"
            >
              <v-card flat>
                <v-card-text>
                  <div>
                    <v-checkbox
                      class="mt-0"
                      v-model="intent.ispriority"
                      color="primary"
                      :label="$t('First Priority')"
                    ></v-checkbox>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="isBeacon" v-show="advancedTab === 'frequency'">
              <v-card flat>
                <v-card-text>
                  <div>
                    <template>
                      <div class="form-control" style="display: flow-root;">
                        <span class="mt-2">
                          {{ $t('Not sending message to the same person within') }}</span
                        >
                        <input
                          type="number"
                          v-model="not_reply_within_seconds"
                          pattern="[0-9]*"
                          placeholder="-"
                          inputmode="numeric"
                          class="form-control ml-2 mr-2"
                          style="width: 90px;"
                        />
                        <span> {{ $t('minute') }}</span>
                      </div>
                    </template>
                    <template>
                      <div class="form-control" style="display: flow-root;">
                        <span class="mt-2"> {{ $t('Send message to same person') }}</span>
                        <input
                          type="number"
                          v-model="intent.not_reply_within_times"
                          pattern="[0-9]*"
                          placeholder="-"
                          inputmode="numeric"
                          class="form-control ml-2 mr-2"
                          style="width: 90px;"
                        /><span> {{ $t('time / day') }}</span>
                      </div>
                    </template>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              v-if="!isBeacon && advancedTab === 'followUp'"
              v-show="advancedTab === 'followUp'"
            >
              <v-card flat>
                <v-card-text style="overflow: auto; padding-bottom: 60px!important;">
                  <v-premium-plan-popup2
                    v-if="!getPackageType().includes('advanced')"
                    type="advanced"
                    text="Upgrade to Advanced, starting at 990 baht/month to Follow-up customers after receiving the message(s) / order summary to buy or track customers' after-sale service."
                  ></v-premium-plan-popup2>
                  <IntentFollowUp
                    :isWelcome="isWelcome"
                    v-model="intent"
                    :isCommentToInbox="isCommentToInbox"
                    :isReplyComment="isReplyComment"
                    :isLiveStream="isLiveStream"
                    :messages2="messages2"
                    :fb_messages="fb_messages2"
                    :line_messages="line_messages2"
                    :whatsapp_messages="whatsapp_messages2"
                    :ig_messages="ig_messages2"
                    :google_messages="google_messages2"
                    :statusOptions="statusOptions"
                    :tagOptions="tagOptions"
                    :follow_up_selectLinenotify.sync="follow_up_selectLinenotify"
                    :showMultipleChannel.sync="showMultipleChannelFollowUp"
                  ></IntentFollowUp>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              v-if="!isBeacon && advancedTab === 'purchase_event'"
              v-show="advancedTab === 'purchase_event'"
            >
              <v-card flat>
                <v-card-text style="overflow: auto; padding-bottom: 60px!important;">
                  <v-premium-plan-popup2
                    v-if="!getPackageType().includes('advanced')"
                    type="advanced"
                    text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                  ></v-premium-plan-popup2>
                  <div class="mb-2 d-flex" style="align-items: center;">
                    <div style="width: 100%">
                      <div class="primary--text caption mb-1">{{ $t('event') }}</div>
                      <v-select
                        name="eventName"
                        :items="eventNames"
                        item-text="label"
                        item-value="value"
                        v-model="eventSetting.event_name"
                        @change="onEventNameChanged"
                        outline
                        v-validate="{ required: eventSetting.value !== '' }"
                        :data-vv-as="$t('event')"
                        :disabled="isVerifySlip"
                      ></v-select>
                      <span
                        class="red--text"
                        style="font-size: 0.9em;"
                        v-if="errors.has('eventName')"
                        >{{ errors.first('eventName') }}</span
                      >
                    </div>
                    <v-btn small icon @click="eventSetting.event_name = ''">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </div>
                  <v-layout row wrap>
                    <v-flex xs6 px-1 d-flex>
                      <div class="form-control" style="width: 100%">
                        <div class="primary--text caption">{{ $t('Amount') }}</div>
                        <input
                          type="text"
                          class="form-control"
                          name="eventSettingValue"
                          ref="eventSettingValue"
                          v-model="eventSetting.value"
                          v-validate="{ required: eventSetting.event_name !== '' }"
                          :data-vv-as="$t('Amount')"
                          :disabled="isVerifySlip"
                        />
                        <span
                          class="red--text"
                          style="font-size: 0.9em;"
                          v-if="errors.has('eventSettingValue')"
                          >{{ errors.first('eventSettingValue') }}</span
                        >
                      </div>
                      <v-menu offset-y open-on-hover v-if="!isVerifySlip">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            fab
                            small
                            outline
                            class="ml-1 extra-small"
                            color="primary"
                            v-on="on"
                          >
                            <span class="fas fa-ellipsis-v"></span>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-tile
                            v-for="(prefill, index) in [{ label: $t('Number'), value: 'number' }]"
                            :key="index"
                            @click="() => insertEventPurchaseValuePrefill(prefill.value)"
                          >
                            <v-list-tile-title class="primary-color">{{
                              $t(prefill.label)
                            }}</v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </v-flex>
                    <v-flex xs6 px-1 d-flex style="align-items: center;">
                      <div class="mb-2" style="width: 100%">
                        <div class="primary--text caption">
                          {{ $t('monetary_unit')
                          }}{{ eventSetting.event_name === 'Purchase' ? '*' : '' }}
                        </div>
                        <v-autocomplete
                          name="currencies"
                          :items="$store.state.currencies"
                          v-model="eventSetting.currency"
                          v-validate="{ required: eventSetting.event_name === 'Purchase' }"
                          :data-vv-as="$t('monetary_unit')"
                          hide-details
                          outline
                        />
                        <span
                          class="red--text"
                          style="font-size: 0.9em;"
                          v-if="errors.has('currencies')"
                          >{{ errors.first('currencies') }}</span
                        >
                      </div>
                      <v-btn small icon @click="eventSetting.currency = ''">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </div>
        </template>
      </div>

      <div class="text-xs-center" style="margin-top: 35px; margin-bottom: 15px">
        <template>
          <input
            type="hidden"
            v-model="intent.q_val"
            v-validate="
              !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname)
                ? 'required'
                : ''
            "
            :data-vv-as="$t('customer says')"
            name="q_val"
          />
          <div class="form-control has-error" style="margin-bottom: 10px">
            <span class="text-error" v-if="errors.has('intentName')">{{
              errors.first('intentName')
            }}</span>
            <span class="text-error" v-else-if="errors.has('q_val')">{{
              errors.first('q_val')
            }}</span>
            <span class="text-error" v-else-if="errors.has('bubbleLimit')">{{
              $t('bubbleLimit')
            }}</span>

            <span class="text-error" v-else-if="errorUserTags.length > 0">
              <template v-if="errorUserTags.includes('duplicate')">{{
                $t('Duplicate Tag')
              }}</template>
            </span>

            <span class="text-error" v-else-if="errors.has('context_in')">{{
              $t('Context In cannot be Comment')
            }}</span>
            <span class="text-error" v-else-if="errors.has('startdate')">{{
              errors.first('startdate')
            }}</span>
            <template v-else>
              <template v-for="(error, errorKey) in errorTag">
                <span :key="errorKey" class="text-error" v-if="error.length > 0">
                  <template v-if="error.includes('overmaxlength')">{{
                    $t('Message cannot be longer than 20 alphabets')
                  }}</template>
                  <template v-else-if="error.includes('overtagmax')">{{
                    $t('Choices cannot be more than 10 items')
                  }}</template>
                  <template v-else-if="error.includes('duplicate')">{{
                    $t('Duplicate Choice')
                  }}</template>
                </span>
              </template>
            </template>
          </div>
          <slot name="footer" :saveIntent="saveIntent" :cancelEdit="cancelEdit">
            <div style="margin-bottom: 15px">
              <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
                <i class="far fa-eye"></i>
                {{ $t('preview') }}
              </a>
              <preview-message
                v-if="showPreview"
                @close="showPreview = false"
                :messages="messages"
                :choice="replies"
                :questions="questions"
                :isComment="isCommentToInbox"
                :comment="replyComment"
              ></preview-message>
            </div>
            <v-btn outline color="grey" @click="cancelEdit">{{ $t('cancel') }}</v-btn>
            <v-btn v-if="!isLivechat" depressed color="primary" @click="saveIntent">{{
              $t('Save')
            }}</v-btn>
            <v-btn v-else depressed color="primary" @click="sendToLivechat">{{ $t('Send') }}</v-btn>
          </slot>
          <!-- {{ intent.a_val }} -->
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import VueTagsInput from '@johmun/vue-tags-input'
import IntentFollowUp from './IntentFollowUp'
import uploadfile from '@/components/elements/uploadfile'
import IntentGroup from './IntentGroup'
import IntentComment from './IntentComment'
import IntentGetstarted from './IntentGetstarted'
import IntentGroupItem from './IntentGroupItem.js'
// import Draggable from 'vuedraggable'
import GenericManage from '@/components/elements/GenericManage'
import MoveHorizontal from '@/components/elements/MoveHorizontal'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import IntentPrefill from './IntentPrefill'

import ModalDialog from '@/components/elements/ModalDialog'
import ModalBlank from '@/components/elements/ModalBlank'
import Tags from '@/components/elements/Tags'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import PreviewMessage from '@/components/elements/PreviewMessage'
import IntentSelectPost from './IntentSelectPost'
import IntentSelectBeacon from './IntentSelectBeacon'
import IntentSelectPostLabel from './IntentSelectPostLabel'
import IntentQuestion from './IntentQuestion'
import dayjs from 'dayjs'

import { VueAutosuggest } from 'vue-autosuggest'
import { ToggleButton } from 'vue-js-toggle-button'
import { cloneDeep } from 'lodash'
import TimePicker from '@/components/elements/TimePicker.vue'
import TimePickerCustom from '@/components/elements/TimePickerCustom.vue'
import EditCustomerValue from '@/components/view/analytics/EditCustomerValue'
import Multiselect from 'vue-multiselect'

import OpenTimeBotItem from '../billing/OpenTimeBotItem'
import MultiSelectCustom from '../../elements/MultiSelectCustom.vue'

const dict = {
  en: {
    custom: {
      intentName: {
        excluded: 'Duplicate Conversation Name',
        excludednew: 'Duplicate Conversation Name'
      }
    }
  },
  th: {
    custom: {
      intentName: {
        excluded: 'ชื่อบทสนทนาซ้ำ',
        excludednew: 'ชื่อบทสนทนาซ้ำ'
      }
    }
  },
  la: {
    custom: {
      intentName: {
        excluded: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ',
        excludednew: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ'
      }
    }
  }
}

export default {
  props: {
    value: {
      type: Object
    },
    type: {
      type: String,
      default: 'add'
    },
    isDefault: {
      type: Boolean,
      default: false
    },
    isWelcome: {
      type: Boolean,
      default: false
    },
    excludedIntentName: {
      type: String,
      default: ''
    },
    isCommentToInbox: {
      type: Boolean,
      default: false
    },
    isLiveStream: {
      type: Boolean,
      default: false
    },
    livechatapp: {
      type: Boolean,
      default: false
    },
    isLivechat: {
      type: Boolean,
      default: false
    },
    isBeacon: {
      type: Boolean,
      default: false
    },
    isIntent: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: false
    },
    noUpdatedAt: {
      type: Boolean,
      default: false
    },
    hasTypeDateAndTime: {
      type: Boolean,
      default: false
    }
  },
  components: {
    IntentFollowUp,
    Multiselect,
    EditCustomerValue,
    VueTagsInput,
    uploadfile,
    IntentGroup,
    IntentComment,
    IntentGetstarted,
    // Draggable,
    GenericManage,
    MoveHorizontal,
    AutoresizeTextarea,
    IntentPrefill,
    IntentSelectBeacon,
    ModalDialog,
    ModalBlank,
    Tags,
    PreviewMessage,
    ViewCartSummaryViewer,
    VueAutosuggest,
    IntentSelectPost,
    IntentQuestion,
    ToggleButton,
    IntentSelectPostLabel,
    TimePicker,
    TimePickerCustom,
    OpenTimeBotItem,
    MultiSelectCustom
  },
  data: function() {
    return {
      errorMaxlengthTags: false,
      errorMaxlength: false,
      showPreview2: false,
      not_reply_within_seconds: null,
      statusOptions: [],
      tagOptions: null,
      tab: 'all',
      tab2: 'all',
      showMultipleChannel: false,
      showMultipleChannelFollowUp: false,
      selectLinenotify: [],
      follow_up_selectLinenotify: [],
      postidlist: { includes: [], excludes: [], post_keywords: [] },
      advancedTab: null,
      showSelectPost: false,
      showSelectBeacon: false,
      showAdvanced: false,
      showPreview: false,
      intent: undefined,

      startDate: null,
      startTime: null,
      openStartDate: false,
      openStartTime: false,
      endDate: null,
      endTime: null,
      openEndDate: false,
      openEndTime: false,

      tag: '',
      usertag: '',
      groups: [],
      generics: [],
      quick_reply: '',
      follow_up_reply: '',
      reply: '',
      text: '',
      messages: [[]],
      messages2: [[]],
      messages_correct: [[]],
      messages_incorrect: [[]],
      messages_error: [[]],
      messages_duplicate: [[]],
      fb_messages: [[]],
      fb_messages2: [[]],
      fb_messages_correct: [[]],
      fb_messages_incorrect: [[]],
      fb_messages_error: [[]],
      fb_messages_duplicate: [[]],
      line_messages: [[]],
      line_messages2: [[]],
      line_messages_correct: [[]],
      line_messages_incorrect: [[]],
      line_messages_error: [[]],
      line_messages_duplicate: [[]],
      whatsapp_messages: [[]],
      whatsapp_messages2: [[]],
      whatsapp_messages_correct: [[]],
      whatsapp_messages_incorrect: [[]],
      whatsapp_messages_error: [[]],
      whatsapp_messages_duplicate: [[]],
      ig_messages: [[]],
      ig_messages2: [[]],
      ig_messages_correct: [[]],
      ig_messages_incorrect: [[]],
      ig_messages_error: [[]],
      ig_messages_duplicate: [[]],
      google_messages: [[]],
      google_messages2: [[]],
      google_messages_correct: [[]],
      google_messages_incorrect: [[]],
      google_messages_error: [[]],
      google_messages_duplicate: [[]],

      errorTag: {
        replies: [],
        facebook: [],
        line: [],
        whatsapp: [],
        instagram: [],
        google: [],
        follow_up_facebook: [],
        follow_up_line: [],
        follow_up_whatsapp: [],
        follow_up_ig: [],
        follow_up_google: [],
        follow_up_replies: []
      },
      errorUserTags: [],
      errorQuestionTag: [],

      isReplyComment: false,
      replyComment: '',
      showEmoji: false,
      excludedName: '',
      intents: [],

      selected: '',
      filteredOptions: [],
      inputProps: {
        id: 'autosuggest__input',
        onInputChange: this.onInputChange,
        placeholder: "Type 'e'"
      },
      limit: 10,
      isremainingreply: false,
      remaining_reply: null,
      notreplysameperson: false,
      timestamp: dayjs().format('x'),
      eventNames: [
        {
          label: 'View Content',
          value: 'ViewContent'
        },
        {
          label: 'Add to Cart',
          value: 'AddToCart'
        },
        {
          label: 'Purchase',
          value: 'Purchase'
        }
      ],
      contextOptions: [
        {
          label: this.$t('contactadmin'),
          value: 'contactadmin'
        }
      ]
    }
  },
  mixins: [IntentGroupItem],
  created: function() {
    var vm = this
    vm.$validator.extend('earlier', {
      getMessage(field, val) {
        return vm.$t('The {field} must be before or equal.', { field: field })
      },
      validate(value, field) {
        if (vm.startTimeFormat || vm.endTimeFormat) {
          var isafter = dayjs(vm.startTimeFormat).isAfter(vm.endTimeFormat)
          return !isafter
        } else {
          return true
        }
      }
    })
  },
  mounted: function() {
    const vm = this
    vm.getUserTagList()
    vm.getUserStatusList()
    vm.$validator.localize(dict)
    vm.$validator.localize(this.currentLang)

    vm.intent = Object.assign({}, vm.value)
    this.not_reply_within_seconds = this.MinuteToSecond(this.intent.not_reply_within_seconds)

    if (typeof vm.intent.follow_up_within_seconds !== 'object') {
      vm.intent.follow_up_within_seconds = {
        HH: ('0' + Math.floor(parseInt(vm.intent.follow_up_within_seconds) / 60 / 60)).slice(-2),
        mm: ('0' + JSON.stringify((parseInt(vm.intent.follow_up_within_seconds) / 60) % 60)).slice(
          -2
        )
      }
    }
    if (typeof vm.intent.follow_up_line_within_seconds !== 'object') {
      const hours = Math.floor(parseInt(vm.intent.follow_up_line_within_seconds) / 60 / 60)
      let HH = ('0' + (hours % 24)).slice(-2)
      let DD = hours >= 24 ? Math.floor(hours / 24) : 0
      let mm = (
        '0' + JSON.stringify((parseInt(vm.intent.follow_up_line_within_seconds) / 60) % 60)
      ).slice(-2)

      if (DD > 0) {
        HH = ('0' + HH).slice(-2)
        DD = ('0' + DD).slice(-2)
        vm.intent.follow_up_line_within_seconds = { DD, HH, mm }
      } else {
        HH = ('0' + HH).slice(-2)
        vm.intent.follow_up_line_within_seconds = { HH, mm }
      }

      if (hours >= 24) {
        vm.intent.follow_up_line_within_seconds_date = Math.floor(hours / 24)
      } else {
        vm.intent.follow_up_line_within_seconds_date = 0
      }
    }

    if (typeof vm.intent.follow_up_fb_within_seconds !== 'object') {
      vm.intent.follow_up_fb_within_seconds = {
        HH: ('0' + Math.floor(parseInt(vm.intent.follow_up_fb_within_seconds) / 60 / 60)).slice(-2),
        mm: (
          '0' + JSON.stringify((parseInt(vm.intent.follow_up_fb_within_seconds) / 60) % 60)
        ).slice(-2)
      }
    }
    if (typeof vm.intent.follow_up_ig_within_seconds !== 'object') {
      vm.intent.follow_up_ig_within_seconds = {
        HH: ('0' + Math.floor(parseInt(vm.intent.follow_up_ig_within_seconds) / 60 / 60)).slice(-2),
        mm: (
          '0' + JSON.stringify((parseInt(vm.intent.follow_up_ig_within_seconds) / 60) % 60)
        ).slice(-2)
      }
    }
    if (typeof vm.intent.follow_up_google_within_seconds !== 'object') {
      vm.intent.follow_up_google_within_seconds = {
        HH: ('0' + Math.floor(parseInt(vm.intent.follow_up_google_within_seconds) / 60 / 60)).slice(
          -2
        ),
        mm: (
          '0' + JSON.stringify((parseInt(vm.intent.follow_up_google_within_seconds) / 60) % 60)
        ).slice(-2)
      }
    }
    // if (typeof vm.intent.follow_up_whatsapp_within_seconds !== 'object'){
    //   vm.intent.follow_up_whatsapp_within_seconds = {
    //     HH: ('0' + Math.floor(parseInt(vm.intent.follow_up_whatsapp_within_seconds) / 60 / 60)).slice(-2),
    //     mm: (
    //       '0' + JSON.stringify((parseInt(vm.intent.follow_up_whatsapp_within_seconds) / 60) % 60)
    //     ).slice(-2)
    //   }
    // }
    if (!vm.intent.postidlist) {
      vm.intent.postidlist = ''
    } else {
      var includes = []
      if (vm.intent.postidlist && vm.intent.postidlist !== '') {
        try {
          includes = JSON.parse(vm.intent.postidlist)
        } catch (error) {
          includes = vm.intent.postidlist.split(',')
        }
      }
      this.$set(this.postidlist, 'includes', includes)
    }
    if (
      // this.check_privilege('multichannel') &&
      vm.intent.fb_val ||
      vm.intent.line_val ||
      vm.intent.ig_val ||
      vm.intent.whatsapp_val ||
      vm.intent.google_val
    ) {
      vm.showMultipleChannel = true
      vm.fb_messages = JSON.parse(vm.intent.fb_val) || [[]]
      vm.line_messages = JSON.parse(vm.intent.line_val) || [[]]
      vm.whatsapp_messages = JSON.parse(vm.intent.whatsapp_val) || [[]]
      vm.ig_messages = JSON.parse(vm.intent.ig_val) || [[]]
      vm.google_messages = JSON.parse(vm.intent.google_val) || [[]]
      vm.tab = 'facebook'
    }

    if (
      this.check_privilege('multichannel') &&
      (vm.intent.follow_up_fb_val ||
        vm.intent.follow_up_line_val ||
        vm.intent.follow_up_ig_val ||
        vm.intent.follow_up_whatsapp_val ||
        vm.intent.follow_up_google_val)
    ) {
      vm.showMultipleChannelFollowUp = true
      vm.fb_messages2 = JSON.parse(vm.intent.follow_up_fb_val) || [[]]
      vm.line_messages2 = JSON.parse(vm.intent.follow_up_line_val) || [[]]
      vm.whatsapp_messages2 = JSON.parse(vm.intent.follow_up_whatsapp_val) || [[]]
      vm.ig_messages2 = JSON.parse(vm.intent.follow_up_ig_val) || [[]]
      vm.google_messages2 = JSON.parse(vm.intent.follow_up_google_val) || [[]]
      vm.tab2 = 'facebook'
    }
    this.timestamp = dayjs().format('x')

    if (vm.isCommentToInbox) {
      vm.remaining_reply = vm.intent.remaining_reply
      vm.notreplysameperson = vm.intent.notreplysameperson
      vm.isremainingreply = vm.intent.remaining_reply != null
    }

    if (!vm.intent.exceptpostidlist) {
      vm.intent.exceptpostidlist = ''
    } else {
      var excludes = []
      if (vm.intent.exceptpostidlist && vm.intent.exceptpostidlist !== '') {
        try {
          excludes = JSON.parse(vm.intent.exceptpostidlist)
        } catch (error) {
          excludes = vm.intent.exceptpostidlist.split(',')
        }
      }
      this.$set(this.postidlist, 'excludes', excludes)
    }

    if (!vm.intent.post_keywords) {
      vm.intent.post_keywords = ''
    } else {
      var post_keywords = []
      if (vm.intent.post_keywords && vm.intent.post_keywords !== '') {
        try {
          post_keywords = JSON.parse(vm.intent.post_keywords)
        } catch (error) {}
      }
      this.$set(this.postidlist, 'post_keywords', post_keywords)
    }
    vm.cached_intent = Object.assign({}, vm.value)

    if (vm.intent.starttime) {
      var startTime = dayjs(vm.intent.starttime || null)
      vm.startDate = startTime.format('YYYY-MM-DD')
      vm.startTime = {
        HH: startTime.format('HH'),
        mm: startTime.format('mm')
      }
    }
    if (vm.intent.endtime) {
      var endTime = dayjs(vm.intent.endtime || null)
      vm.endDate = endTime.format('YYYY-MM-DD')
      vm.endTime = {
        HH: endTime.format('HH'),
        mm: endTime.format('mm')
      }
    }

    if (vm.intent.linenoti_spec_ids) {
      this.selectLinenotify = this.$store.state.linenotifylist.filter(el => {
        return vm.intent.linenoti_spec_ids.indexOf(el.id) != -1
      })
    }

    if (vm.intent.follow_up_linenoti_spec_ids) {
      this.follow_up_selectLinenotify = this.$store.state.linenotifylist.filter(el => {
        return vm.intent.follow_up_linenoti_spec_ids.indexOf(el.id) != -1
      })
    }

    vm.intents = vm.excludedIntentName.split(',')
    vm.intents.push('comment')
    vm.intents.push('{default}')
    vm.intents.push('{welcome}')
    vm.intents.push('{default_comment_to_inbox}')

    vm.intent.onlytime =
      vm.intent.onlytime === null ? null : vm.intent.onlytime ? vm.intent.onlytime : false

    if (vm.intent.onlytime === null && vm.intent.time_setting) {
      vm.intent.time_setting = {
        Monday: vm.intent.time_setting.Monday || { status: true, openat: null, closeat: null },
        Tuesday: vm.intent.time_setting.Tuesday || { status: true, openat: null, closeat: null },
        Wednesday: vm.intent.time_setting.Wednesday || {
          status: true,
          openat: null,
          closeat: null
        },
        Thursday: vm.intent.time_setting.Thursday || { status: true, openat: null, closeat: null },
        Friday: vm.intent.time_setting.Friday || { status: true, openat: null, closeat: null },
        Saturday: vm.intent.time_setting.Saturday || { status: true, openat: null, closeat: null },
        Sunday: vm.intent.time_setting.Sunday || { status: true, openat: null, closeat: null }
      }
    } else {
      vm.intent.onlytime = vm.intent.onlytime === null ? false : vm.intent.onlytime
      vm.intent.time_setting = {
        Monday: { status: true, openat: null, closeat: null },
        Tuesday: { status: true, openat: null, closeat: null },
        Wednesday: {
          status: true,
          openat: null,
          closeat: null
        },
        Thursday: { status: true, openat: null, closeat: null },
        Friday: { status: true, openat: null, closeat: null },
        Saturday: { status: true, openat: null, closeat: null },
        Sunday: { status: true, openat: null, closeat: null }
      }
    }

    if (vm.isCommentToInbox && !vm.isLiveStream) {
      vm.isReplyComment = true
      vm.intent.context_in = 'comment'
    } else if (vm.isLiveStream) {
      vm.intent.context_in = 'facebooklive'
    }
    var names = []
    if (vm.type === 'edit' && vm.excludedIntentName && vm.excludedIntentName !== '' && vm.intent) {
      names = vm.intents
      try {
        let index = names.findIndex(name => {
          return vm.isBeacon ? name === vm.intent.campaign_name : name === vm.intent.intentname
        })

        if (index != -1) names.splice(index, 1)
      } catch (error) {
        console.log(error)
      }

      names = names.map(el => {
        return el.replace(/,/g, '')
      })

      vm.excludedName = names.join(',').replace(/[|]/g, '//#or//')
    } else {
      names = vm.intents.map(el => {
        return el.replace(/,/g, '')
      })

      vm.excludedName = names.join(',').replace(/[|]/g, '//#or//')
    }

    if (vm.value.context_in === 'comment') {
      if (vm.value.a_type === 'json') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          var message = JSON.parse(vm.value.a_val)
          vm.messages2 = JSON.parse(vm.value.follow_up_val) || [[]]
          if (message[0][0].type === 'text') {
            vm.messages = [
              [
                {
                  type: 'responsepost',
                  replyinbox: true,
                  replycomment: false,
                  hidecomment: false,
                  is_like_comment: false,
                  responseinbox: [
                    {
                      type: 'text',
                      text: message[0][0].text
                    }
                  ],
                  responsecomment: [
                    {
                      type: 'text',
                      text: ''
                    }
                  ]
                }
              ]
            ]
          } else if (message[0][0].type === 'responsepost') {
            vm.messages = message
          }
        } else {
          vm.messages = [
            [
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                is_like_comment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: vm.value.a_val
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ]
          ]
        }
      } else {
        vm.messages = [
          [
            {
              type: 'responsepost',
              replyinbox: true,
              replycomment: false,
              hidecomment: false,
              is_like_comment: false,
              responseinbox: [
                {
                  type: 'text',
                  text: vm.value.a_val
                }
              ],
              responsecomment: [
                {
                  type: 'text',
                  text: ''
                }
              ]
            }
          ]
        ]
      }
    } else if (vm.value.a_type === 'json') {
      if (vm.isJsonParseable(vm.value.a_val)) {
        vm.messages = JSON.parse(vm.value.a_val)
      } else {
        vm.messages = [[]]
      }
      if (vm.value.follow_up_val && vm.isJsonParseable(vm.value.follow_up_val)) {
        vm.messages2 = JSON.parse(vm.value.follow_up_val)
      } else {
        vm.messages2 = [[]]
      }

      if (vm.value.verify_slip_setting && Object.keys(vm.value.verify_slip_setting).length) {
        if (
          vm.value.verify_slip_setting.correct_a_val &&
          vm.value.verify_slip_setting.correct_a_val.length
        ) {
          vm.messages_correct[0].push(...vm.value.verify_slip_setting.correct_a_val)
        }
        if (
          vm.value.verify_slip_setting.incorrect_a_val &&
          vm.value.verify_slip_setting.incorrect_a_val.length
        ) {
          vm.messages_incorrect[0].push(...vm.value.verify_slip_setting.incorrect_a_val)
        }
        if (
          vm.value.verify_slip_setting.error_a_val &&
          vm.value.verify_slip_setting.error_a_val.length
        ) {
          vm.messages_error[0].push(...vm.value.verify_slip_setting.error_a_val)
        }
        if (
          vm.value.verify_slip_setting.duplicate_a_val &&
          vm.value.verify_slip_setting.duplicate_a_val.length
        ) {
          vm.messages_duplicate[0].push(...vm.value.verify_slip_setting.duplicate_a_val)
        }
        if (
          vm.value.verify_slip_setting.correct_fb_val &&
          vm.value.verify_slip_setting.correct_fb_val.length
        ) {
          vm.fb_messages_correct[0].push(...vm.value.verify_slip_setting.correct_fb_val)
        }
        if (
          vm.value.verify_slip_setting.incorrect_fb_val &&
          vm.value.verify_slip_setting.incorrect_fb_val.length
        ) {
          vm.fb_messages_incorrect[0].push(...vm.value.verify_slip_setting.incorrect_fb_val)
        }
        if (
          vm.value.verify_slip_setting.error_fb_val &&
          vm.value.verify_slip_setting.error_fb_val.length
        ) {
          vm.fb_messages_error[0].push(...vm.value.verify_slip_setting.error_fb_val)
        }
        if (
          vm.value.verify_slip_setting.duplicate_fb_val &&
          vm.value.verify_slip_setting.duplicate_fb_val.length
        ) {
          vm.fb_messages_duplicate[0].push(...vm.value.verify_slip_setting.duplicate_fb_val)
        }
        if (
          vm.value.verify_slip_setting.correct_line_val &&
          vm.value.verify_slip_setting.correct_line_val.length
        ) {
          vm.line_messages_correct[0].push(...vm.value.verify_slip_setting.correct_line_val)
        }
        if (
          vm.value.verify_slip_setting.incorrect_line_val &&
          vm.value.verify_slip_setting.incorrect_line_val.length
        ) {
          vm.line_messages_incorrect[0].push(...vm.value.verify_slip_setting.incorrect_line_val)
        }
        if (
          vm.value.verify_slip_setting.error_line_val &&
          vm.value.verify_slip_setting.error_line_val.length
        ) {
          vm.line_messages_error[0].push(...vm.value.verify_slip_setting.error_line_val)
        }
        if (
          vm.value.verify_slip_setting.duplicate_line_val &&
          vm.value.verify_slip_setting.duplicate_line_val.length
        ) {
          vm.line_messages_duplicate[0].push(...vm.value.verify_slip_setting.duplicate_line_val)
        }
        if (
          vm.value.verify_slip_setting.correct_ig_val &&
          vm.value.verify_slip_setting.correct_ig_val.length
        ) {
          vm.ig_messages_correct[0].push(...vm.value.verify_slip_setting.correct_ig_val)
        }
        if (
          vm.value.verify_slip_setting.incorrect_ig_val &&
          vm.value.verify_slip_setting.incorrect_ig_val.length
        ) {
          vm.ig_messages_incorrect[0].push(...vm.value.verify_slip_setting.incorrect_ig_val)
        }
        if (
          vm.value.verify_slip_setting.error_ig_val &&
          vm.value.verify_slip_setting.error_ig_val.length
        ) {
          vm.ig_messages_error[0].push(...vm.value.verify_slip_setting.error_ig_val)
        }
        if (
          vm.value.verify_slip_setting.duplicate_ig_val &&
          vm.value.verify_slip_setting.duplicate_ig_val.length
        ) {
          vm.ig_messages_duplicate[0].push(...vm.value.verify_slip_setting.duplicate_ig_val)
        }
        if (
          vm.value.verify_slip_setting.correct_google_val &&
          vm.value.verify_slip_setting.correct_google_val.length
        ) {
          vm.google_messages_correct[0].push(...vm.value.verify_slip_setting.correct_google_val)
        }
        if (
          vm.value.verify_slip_setting.incorrect_google_val &&
          vm.value.verify_slip_setting.incorrect_google_val.length
        ) {
          vm.google_messages_incorrect[0].push(...vm.value.verify_slip_setting.incorrect_google_val)
        }
        if (
          vm.value.verify_slip_setting.error_google_val &&
          vm.value.verify_slip_setting.error_google_val.length
        ) {
          vm.google_messages_error[0].push(...vm.value.verify_slip_setting.error_google_val)
        }
        if (
          vm.value.verify_slip_setting.duplicate_google_val &&
          vm.value.verify_slip_setting.duplicate_google_val.length
        ) {
          vm.google_messages_duplicate[0].push(...vm.value.verify_slip_setting.duplicate_google_val)
        }
        if (
          vm.value.verify_slip_setting.correct_whatsapp_val &&
          vm.value.verify_slip_setting.correct_whatsapp_val.length
        ) {
          vm.whatsapp_messages_correct[0].push(...vm.value.verify_slip_setting.correct_whatsapp_val)
        }
        if (
          vm.value.verify_slip_setting.incorrect_whatsapp_val &&
          vm.value.verify_slip_setting.incorrect_whatsapp_val.length
        ) {
          vm.whatsapp_messages_incorrect[0].push(
            ...vm.value.verify_slip_setting.incorrect_whatsapp_val
          )
        }
        if (
          vm.value.verify_slip_setting.error_whatsapp_val &&
          vm.value.verify_slip_setting.error_whatsapp_val.length
        ) {
          vm.whatsapp_messages_error[0].push(...vm.value.verify_slip_setting.error_whatsapp_val)
        }
        if (
          vm.value.verify_slip_setting.duplicate_whatsapp_val &&
          vm.value.verify_slip_setting.duplicate_whatsapp_val.length
        ) {
          vm.whatsapp_messages_duplicate[0].push(
            ...vm.value.verify_slip_setting.duplicate_whatsapp_val
          )
        }
      } else if (
        // this.check_privilege('multichannel') &&
        vm.intent.fb_val ||
        vm.intent.line_val ||
        vm.intent.ig_val ||
        vm.intent.whatsapp_val ||
        vm.intent.google_val
      ) {
        vm.showMultipleChannel = true
        vm.fb_messages_correct = JSON.parse(vm.intent.fb_val) || [[]]
        vm.fb_messages_incorrect = JSON.parse(vm.intent.fb_val) || [[]]
        vm.fb_messages_error = JSON.parse(vm.intent.fb_val) || [[]]
        vm.fb_messages_duplicate = JSON.parse(vm.intent.fb_val) || [[]]
        vm.line_messages_correct = JSON.parse(vm.intent.line_val) || [[]]
        vm.line_messages_incorrect = JSON.parse(vm.intent.line_val) || [[]]
        vm.line_messages_error = JSON.parse(vm.intent.line_val) || [[]]
        vm.line_messages_duplicate = JSON.parse(vm.intent.line_val) || [[]]
        vm.whatsapp_messages_correct = JSON.parse(vm.intent.whatsapp_val) || [[]]
        vm.whatsapp_messages_incorrect = JSON.parse(vm.intent.whatsapp_val) || [[]]
        vm.whatsapp_messages_error = JSON.parse(vm.intent.whatsapp_val) || [[]]
        vm.whatsapp_messages_duplicate = JSON.parse(vm.intent.whatsapp_val) || [[]]
        vm.ig_messages_correct = JSON.parse(vm.intent.ig_val) || [[]]
        vm.ig_messages_incorrect = JSON.parse(vm.intent.ig_val) || [[]]
        vm.ig_messages_error = JSON.parse(vm.intent.ig_val) || [[]]
        vm.ig_messages_duplicate = JSON.parse(vm.intent.ig_val) || [[]]
        vm.google_messages_correct = JSON.parse(vm.intent.google_val) || [[]]
        vm.google_messages_incorrect = JSON.parse(vm.intent.google_val) || [[]]
        vm.google_messages_error = JSON.parse(vm.intent.google_val) || [[]]
        vm.google_messages_duplicate = JSON.parse(vm.intent.google_val) || [[]]
        vm.tab = 'facebook'
      } else if (vm.isJsonParseable(vm.value.a_val)) {
        vm.messages_correct = JSON.parse(vm.value.a_val)
        vm.messages_incorrect = JSON.parse(vm.value.a_val)
        vm.messages_error = JSON.parse(vm.value.a_val)
        vm.messages_duplicate = JSON.parse(vm.value.a_val)
      }
    } else {
      if (vm.value.a_val === '{welcome_message}') {
        vm.messages = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (vm.value.a_type === 'text') {
        var newGroup = []
        var group = vm.value.a_val.split('||')
        $.each(group, function(index, messages) {
          var newMessage = []
          var groupMessages = messages.split('#nl')
          $.each(groupMessages, function(index, message) {
            var type = 'text'
            if (!isNaN(message)) {
              newMessage.push({
                type: 'text',
                text: message
              })
            } else if (vm.isJsonParseable(message)) {
              var messageParsed = JSON.parse(message)
              newMessage.push({
                text: messageParsed.text,
                buttons: messageParsed.buttons,
                type: 'button'
              })
            } else if (vm.isURL(message)) {
              newMessage.push({
                type: 'image',
                image_url: message
              })
            } else {
              newMessage.push({
                type: 'text',
                text: message
              })
            }
          })
          newGroup.push(newMessage)
        })
        vm.messages = newGroup
      } else if (vm.value.a_type === 'message') {
        vm.messages = [
          [
            {
              type: 'text',
              data: vm.value.a_val
            }
          ]
        ]
      } else if (vm.value.a_type === 'template') {
        vm.messages = [
          [
            {
              type: 'generic',
              data: JSON.parse(vm.value.a_val),
              altText: vm.value.altText,
              ratio: vm.value.ratio == 'horizontal' ? 'horizontal' : 'square'
            }
          ]
        ]
      } else if (vm.value.a_type === 'message') {
      } else if (vm.value.a_type === 'generic') {
      } else if (vm.value.a_type === 'viewsummary') {
        vm.messages = [
          [
            {
              type: 'text',
              text: '{viewsummary}'
            }
          ]
        ]
      }
    }
  },
  computed: {
    showReplyCommentSelectPost() {
      return this.isReplyComment && this.isCommentToInbox && !this.isLiveStream
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      setting: 'setting',
      currentLang: 'currentLang',
      isCoachlab: 'isCoachlab',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus',
      userTags: 'getUserTags',
      loadingUserTags: 'getLoadingUserTags'
    }),
    welcomeMessage() {
      let { messages } = this.$store.getters.welcomeMessage(this.tab)
      return messages
    },

    tags: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.q_val && vm.intent.q_val !== '') {
          var tags = vm.intent.q_val.split(',')
          var result = []
          try {
            result = tags(function(val) {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        try {
          result = value.map(function(val) {
            return val.text
          })
        } catch (error) {
          console.log(error)
        }
        vm.intent.q_val = result.join(',')
      }
    },
    replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.quick_reply && vm.intent.quick_reply !== '') {
          // console.log(vm.intent.quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {
          console.log(error)
        }
        this.$set(this.intent, 'quick_reply', result.join(','))
      }
    },

    fb_replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.fb_quick_reply && vm.intent.fb_quick_reply !== '') {
          // console.log(vm.intent.fb_quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.fb_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {
          console.log(error)
        }
        this.$set(this.intent, 'fb_quick_reply', result.join(','))
      }
    },

    line_replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.line_quick_reply && vm.intent.line_quick_reply !== '') {
          // console.log(vm.intent.line_quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.line_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {
          console.log(error)
        }
        this.$set(this.intent, 'line_quick_reply', result.join(','))
      }
    },

    ig_replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.ig_quick_reply && vm.intent.ig_quick_reply !== '') {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.ig_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {
            console.log(error)
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        let result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {
          console.log(error)
        }
        vm.$set(vm.intent, 'ig_quick_reply', result.join(','))
      }
    },

    google_replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.google_quick_reply && vm.intent.google_quick_reply !== '') {
          let quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.google_quick_reply.split(',')
          }
          let result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {
            console.log(error)
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        let result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {
          console.log(error)
        }
        vm.$set(vm.intent, 'google_quick_reply', result.join(','))
      }
    },

    whatsapp_replies: {
      get() {
        const vm = this
        if (vm.intent && vm.intent.whatsapp_quick_reply && vm.intent.whatsapp_quick_reply !== '') {
          let quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.whatsapp_quick_reply.split(',')
          }
          let result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        let result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        vm.$set(vm.intent, 'whatsapp_quick_reply', result.join(','))
      }
    },

    usertags: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.usertags && vm.intent.usertags !== '') {
          var usertags = []

          usertags = vm.intent.usertags.split(',')
          var result = []
          if (usertags) {
            try {
              result = usertags.map(function(tag) {
                return { text: tag }
              })
            } catch (error) {}
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        if (value) {
          result = value.map(function(tag) {
            return tag.text
          })
        }

        this.$set(this.intent, 'usertags', result.join(','))
      }
    },
    questions: function() {
      var result = []
      try {
        var questions = this.formatQuestionData(this.intent.q_val)
        if (questions.normal) {
          result = questions.normal.map(el => {
            return el.text
          })
        } else if (questions.keyword) {
          result = questions.keyword.map(el => {
            return el.text
          })
        } else if (questions.exactly) {
          result = questions.exactly.map(el => {
            return el.text
          })
        } else if (questions.startwith) {
          result = questions.startwith.map(el => {
            return el.text
          })
        } else if (questions.endwith) {
          result = questions.endwith.map(el => {
            return el.text
          })
        } else if (questions.startandendwith) {
          result = questions.startandendwith.map(el => {
            return el.text
          })
        }
        // result = questions.map(function(val) {
        //   return val.text
        // })
      } catch (error) {
        console.log(error)
      }
      return result
    },
    startTimeFormat: function() {
      var time = null
      var vm = this

      try {
        if (this.intent.onlytime) {
          if (this.startTime)
            time = dayjs().format('YYYY-MM-DD') + ' ' + this.formatTime(this.startTime) + ':00'
        } else if (vm.startDate) {
          time = vm.startDate + ' ' + this.formatTime(this.startTime) + ':00'
        }
      } catch (error) {
        console.log(error)
      }

      return time
    },
    endTimeFormat: function() {
      var time = null
      var vm = this
      if (this.intent.onlytime) {
        if (this.endTime)
          time =
            dayjs().format('YYYY-MM-DD') +
            ' ' +
            this.formatTime(this.endTime, {
              defaultHour: 23,
              defaultMinius: 59
            }) +
            ':00'
      } else if (vm.endDate) {
        time =
          vm.endDate +
          ' ' +
          this.formatTime(this.endTime, {
            defaultHour: 23,
            defaultMinius: 59
          }) +
          ':00'
      }
      return time
    },
    eventSetting: {
      get() {
        if (this.intent.event_setting) return this.intent.event_setting

        return {
          event_name: '',
          value: '',
          currency: 'THB'
        }
      },
      set(value) {
        this.intent.event_setting = value
      }
    },
    isVerifySlip() {
      return this.intent.q_val.includes('{verify_slip.bank_info')
    },
    startTimeInput: {
      get() {
        if (this.startTime && this.startTime.HH && this.startTime.HH) {
          return `${this.startTime.HH || '00'}:${this.startTime.mm || '00'}`
        } else {
          return null
        }
      },
      set(value) {
        if (value) {
          const [HH, mm] = value.split(':')
          this.startTime = {
            HH: HH || '00',
            mm: mm || '00'
          }
        } else {
          this.startTime = null
        }
      }
    },
    endTimeInput: {
      get() {
        if (this.endTime && this.endTime.HH && this.endTime.HH) {
          return `${this.endTime.HH || '00'}:${this.endTime.mm || '00'}`
        } else {
          return null
        }
      },
      set(value) {
        if (value) {
          const [HH, mm] = value.split(':')
          this.endTime = {
            HH: HH || '00',
            mm: mm || '00'
          }
        } else {
          this.endTime = null
        }
      }
    },
    channels() {
      const advancedExpired = this.selectedBot.advanced_expireat || null
      if (!advancedExpired) {
        return this.channelItem.map(item => ({
          ...item,
          disabled: item.name !== 'facebook'
          // disabled: item.name !== 'facebook'
        }))
      } else {
        let a = dayjs(advancedExpired)
        let b = dayjs()
        const isOutOfTime = b.diff(a, 'days') > 0
        return this.channelItem.map(item => ({
          ...item,
          disabled: isOutOfTime && item.name !== 'facebook'
          // disabled: item.name !== 'facebook'
        }))
      }
    }
  },
  methods: {
    startTimeFormatFN: function() {
      var time = null
      var vm = this

      try {
        if (this.intent.onlytime) {
          if (this.startTime)
            time = `${dayjs().format('YYYY-MM-DD')} ${this.formatTime(this.startTime)}:00`
        } else if (vm.startDate) {
          time = `${vm.startDate} ${this.formatTime(this.startTime)}:00`
        }
      } catch (error) {
        console.log(error)
      }

      return time
    },
    endTimeFormatFN: function() {
      var time = null
      var vm = this
      if (this.intent.onlytime) {
        if (this.endTime)
          time = `${dayjs().format('YYYY-MM-DD')} ${this.formatTime(this.endTime, {
            defaultHour: 23,
            defaultMinius: 59
          })}:00`
      } else if (vm.endDate) {
        time = `${vm.endDate} ${this.formatTime(this.endTime, {
          defaultHour: 23,
          defaultMinius: 59
        })}:00`
      }
      return time
    },
    clearToWayVerify() {
      const vm = this
      vm.$refs.form.clearVerify()
    },
    onClickClearVerifySlip() {
      const vm = this
      if (vm.messages[0].length !== 0) {
        vm.messages[0] = vm.messages[0].filter(item => !item.text.includes('{verify_slip.ref_no}'))
      }
      if (vm.fb_messages[0].length !== 0) {
        vm.fb_messages[0] = vm.fb_messages[0].filter(
          item => !item.text.includes('{verify_slip.ref_no}')
        )
      }
      if (vm.line_messages[0].length !== 0) {
        vm.line_messages[0] = vm.line_messages[0].filter(
          item => !item.text.includes('{verify_slip.ref_no}')
        )
      }
      if (vm.whatsapp_messages[0].length !== 0) {
        vm.whatsapp_messages[0] = vm.whatsapp_messages[0].filter(
          item => !item.text.includes('{verify_slip.ref_no}')
        )
      }
      if (vm.ig_messages[0].length !== 0) {
        vm.ig_messages[0] = vm.ig_messages[0].filter(
          item => !item.text.includes('{verify_slip.ref_no}')
        )
      }
      if (vm.google_messages[0].length !== 0) {
        vm.google_messages[0] = vm.google_messages[0].filter(
          item => !item.text.includes('{verify_slip.ref_no}')
        )
      }

      const clearVerifySlip = arr => {
        let newArr = [...arr]
        if (arr.length) {
          newArr[0] = newArr[0].filter(item => !item.text.includes('{verify_slip.ref_no}'))
        }

        return newArr
      }

      vm.messages_correct = clearVerifySlip(vm.messages_correct)
      vm.messages_incorrect = clearVerifySlip(vm.messages_incorrect)
      vm.messages_error = clearVerifySlip(vm.messages_error)
      vm.messages_duplicate = clearVerifySlip(vm.messages_duplicate)
      vm.fb_messages_correct = clearVerifySlip(vm.fb_messages_correct)
      vm.fb_messages_incorrect = clearVerifySlip(vm.fb_messages_incorrect)
      vm.fb_messages_error = clearVerifySlip(vm.fb_messages_error)
      vm.fb_messages_duplicate = clearVerifySlip(vm.fb_messages_duplicate)
      vm.line_messages_correct = clearVerifySlip(vm.line_messages_correct)
      vm.line_messages_incorrect = clearVerifySlip(vm.line_messages_incorrect)
      vm.line_messages_error = clearVerifySlip(vm.line_messages_error)
      vm.line_messages_duplicate = clearVerifySlip(vm.line_messages_duplicate)
      vm.whatsapp_messages_correct = clearVerifySlip(vm.whatsapp_messages_correct)
      vm.whatsapp_messages_incorrect = clearVerifySlip(vm.whatsapp_messages_incorrect)
      vm.whatsapp_messages_error = clearVerifySlip(vm.whatsapp_messages_error)
      vm.whatsapp_messages_duplicate = clearVerifySlip(vm.whatsapp_messages_duplicate)
      vm.ig_messages_correct = clearVerifySlip(vm.ig_messages_correct)
      vm.ig_messages_incorrect = clearVerifySlip(vm.ig_messages_incorrect)
      vm.ig_messages_error = clearVerifySlip(vm.ig_messages_error)
      vm.ig_messages_duplicate = clearVerifySlip(vm.ig_messages_duplicate)
      vm.google_messages_correct = clearVerifySlip(vm.google_messages_correct)
      vm.google_messages_incorrect = clearVerifySlip(vm.google_messages_incorrect)
      vm.google_messages_error = clearVerifySlip(vm.google_messages_error)
      vm.google_messages_duplicate = clearVerifySlip(vm.google_messages_duplicate)
      vm.changeTimestamp()
    },
    onClickVerifySlip({ eventPurchase }) {
      const text = `สถานะ: {verify_slip.result}

ชื่อผู้โอน: {verify_slip.transfer_name}
โอนจาก: {verify_slip.sending_bank}

ชื่อผู้รับ: {verify_slip.receive_name}
โอนถึง: {verify_slip.receiving_bank}

เลขอ้างอิง: {verify_slip.ref_no}
ยอดเงิน: {verify_slip.amount}

วันที่: {verify_slip.bank_transfer_date}
เวลา: {verify_slip.bank_transfer_time}`

      const vm = this

      if (!JSON.stringify(vm.messages[0]).includes('{verify_slip.ref_no}')) {
        vm.messages[0].push({
          text: text,
          type: 'text'
        })
        // vm.messages_correct[0].push({
        //   text: text,
        //   type: 'text'
        // })
        // vm.messages_incorrect[0].push({
        //   text: text,
        //   type: 'text'
        // })
        // vm.messages_error[0].push({
        //   text: text,
        //   type: 'text'
        // })
      }

      const addVerifySlip = arr => {
        let newArr = [...arr]
        if (arr.length && arr[0] && !JSON.stringify(arr[0]).includes('{verify_slip.ref_no}')) {
          newArr = [arr[0]]
          newArr[0].push({ text: text, type: 'text' })
        }
        return newArr
      }

      vm.messages_correct = addVerifySlip(vm.messages_correct)
      vm.messages_incorrect = addVerifySlip(vm.messages_incorrect)
      vm.messages_error = addVerifySlip(vm.messages_error)
      vm.messages_duplicate = addVerifySlip(vm.messages_duplicate)
      vm.fb_messages_correct = addVerifySlip(vm.fb_messages_correct)
      vm.fb_messages_incorrect = addVerifySlip(vm.fb_messages_incorrect)
      vm.fb_messages_error = addVerifySlip(vm.fb_messages_error)
      vm.fb_messages_duplicate = addVerifySlip(vm.fb_messages_duplicate)
      vm.line_messages_correct = addVerifySlip(vm.line_messages_correct)
      vm.line_messages_incorrect = addVerifySlip(vm.line_messages_incorrect)
      vm.line_messages_error = addVerifySlip(vm.line_messages_error)
      vm.line_messages_duplicate = addVerifySlip(vm.line_messages_duplicate)
      vm.whatsapp_messages_correct = addVerifySlip(vm.whatsapp_messages_correct)
      vm.whatsapp_messages_incorrect = addVerifySlip(vm.whatsapp_messages_incorrect)
      vm.whatsapp_messages_error = addVerifySlip(vm.whatsapp_messages_error)
      vm.whatsapp_messages_duplicate = addVerifySlip(vm.whatsapp_messages_duplicate)
      vm.ig_messages_correct = addVerifySlip(vm.ig_messages_correct)
      vm.ig_messages_incorrect = addVerifySlip(vm.ig_messages_incorrect)
      vm.ig_messages_error = addVerifySlip(vm.ig_messages_error)
      vm.ig_messages_duplicate = addVerifySlip(vm.ig_messages_duplicate)
      vm.google_messages_correct = addVerifySlip(vm.google_messages_correct)
      vm.google_messages_incorrect = addVerifySlip(vm.google_messages_incorrect)
      vm.google_messages_error = addVerifySlip(vm.google_messages_error)
      vm.google_messages_duplicate = addVerifySlip(vm.google_messages_duplicate)
      vm.clearRandom()
      if (eventPurchase) {
        this.eventSetting = {
          event_name: 'Purchase',
          value: '{number}',
          currency: 'THB'
        }
      } else {
        this.eventSetting = {
          event_name: '',
          value: '',
          currency: 'THB'
        }
      }
    },
    clearRandom() {
      const checkLength = arr => {
        return arr.some(a => a.length > 1)
      }

      const isRandom = checkLength([
        this.messages,
        this.fb_messages,
        this.line_messages,
        this.whatsapp_messages,
        this.ig_messages,
        this.google_messages
      ])

      if (isRandom) {
        const intentGroupRef = this.$refs.intentGroup
        if (intentGroupRef) {
          intentGroupRef.closeRandomStatus()
        }
      }
    },
    openLink(link) {
      window.open(link, '_blank')
    },
    handleContextIn(tag) {
      console.log({ tag })
    },
    onSelectStatus(value) {
      if (value.length <= 25) {
        this.errorMaxlength = false
        this.intent.userstatus = value
      } else {
        this.errorMaxlength = true
      }
    },
    async getUserTagList() {
      const vm = this
      await vm.$store.dispatch('loadTags')
      if (vm.userTags.length > 0) {
        vm.tagOptions = vm.userTags.map(item => {
          return item.name || ''
        })
        this.timestamp = dayjs().format('x')
      }
    },
    async getUserStatusList() {
      const vm = this
      await vm.$store.dispatch('loadStatus')
      if (vm.userStatus.length > 0) {
        vm.statusOptions = vm.userStatus.map(item => {
          return item.name
        })
      }
    },
    countBeaconID(beacon) {
      return `(${beacon.split(',').length})`
    },
    changeTimestamp() {
      this.timestamp = dayjs().format('x')
    },

    async changeSetting(payload) {
      const vm = this
      if (
        (vm.$store.getters.getPackage == 'premium' || vm.selectedBot.pagetype == 'enterprise') &&
        payload.hasOwnProperty('showMultipleChannel')
      ) {
        if (
          vm.showMultipleChannel != payload.showMultipleChannel &&
          payload.showMultipleChannel == true
        ) {
          if (vm.isWelcome) {
            try {
              await vm.$nextTick()
              let { messages } = vm.$store.getters.welcomeMessage('all')
              var fb_messages = cloneDeep(messages)
              vm.fb_messages = fb_messages.map(el => {
                return el.filter(sel => {
                  return !['flex', 'imagemap', 'sticker'].includes(sel.type)
                }, [])
              }, [])

              vm.line_messages = cloneDeep(messages)
              vm.whatsapp_messages = cloneDeep(messages)
              vm.google_messages = cloneDeep(messages)
              vm.ig_messages = cloneDeep(messages)
              vm.ig_messages = vm.ig_messages.map(el => {
                return el.filter(sel => {
                  return !['flex', 'imagemap', 'sticker'].includes(sel.type)
                }, [])
              }, [])
            } catch (error) {
              console.log(error)
            }
          } else {
            var fb_messages = cloneDeep(vm.messages)
            var fb_messages_correct = cloneDeep(vm.messages_correct)
            var fb_messages_incorrect = cloneDeep(vm.messages_incorrect)
            var fb_messages_error = cloneDeep(vm.messages_error)
            var fb_messages_duplicate = cloneDeep(vm.messages_duplicate)
            vm.fb_messages = fb_messages.map(el => {
              return el.filter(sel => {
                return !['flex', 'imagemap', 'sticker'].includes(sel.type)
              }, [])
            }, [])
            vm.fb_messages_correct = fb_messages_correct.map(el => {
              return el.filter(sel => {
                return !['flex', 'imagemap', 'sticker'].includes(sel.type)
              }, [])
            }, [])
            vm.fb_messages_incorrect = fb_messages_incorrect.map(el => {
              return el.filter(sel => {
                return !['flex', 'imagemap', 'sticker'].includes(sel.type)
              }, [])
            }, [])
            vm.fb_messages_error = fb_messages_error.map(el => {
              return el.filter(sel => {
                return !['flex', 'imagemap', 'sticker'].includes(sel.type)
              }, [])
            }, [])
            vm.fb_messages_duplicate = fb_messages_duplicate.map(el => {
              return el.filter(sel => {
                return !['flex', 'imagemap', 'sticker'].includes(sel.type)
              }, [])
            }, [])
            vm.line_messages = cloneDeep(vm.messages)
            vm.line_messages_correct = cloneDeep(vm.messages_correct)
            vm.line_messages_incorrect = cloneDeep(vm.messages_incorrect)
            vm.line_messages_error = cloneDeep(vm.messages_error)
            vm.line_messages_duplicate = cloneDeep(vm.messages_duplicate)
            vm.whatsapp_messages = cloneDeep(vm.messages)
            vm.whatsapp_messages_correct = cloneDeep(vm.messages_correct)
            vm.whatsapp_messages_incorrect = cloneDeep(vm.messages_incorrect)
            vm.whatsapp_messages_error = cloneDeep(vm.messages_error)
            vm.whatsapp_messages_duplicate = cloneDeep(vm.messages_duplicate)
            vm.google_messages = cloneDeep(vm.messages)
            vm.google_messages_correct = cloneDeep(vm.messages_correct)
            vm.google_messages_incorrect = cloneDeep(vm.messages_incorrect)
            vm.google_messages_error = cloneDeep(vm.messages_error)
            vm.google_messages_duplicate = cloneDeep(vm.messages_duplicate)
            vm.ig_messages = cloneDeep(vm.messages)
            vm.ig_messages_correct = cloneDeep(vm.messages_correct)
            vm.ig_messages_incorrect = cloneDeep(vm.messages_incorrect)
            vm.ig_messages_error = cloneDeep(vm.messages_error)
            vm.ig_messages_duplicate = cloneDeep(vm.messages_duplicate)
            vm.ig_messages = vm.ig_messages.map(el => {
              return el.filter(sel => {
                return !['flex', 'imagemap', 'sticker'].includes(sel.type)
              }, [])
            }, [])
            vm.ig_messages_correct = vm.ig_messages_correct.map(el => {
              return el.filter(sel => {
                return !['flex', 'imagemap', 'sticker'].includes(sel.type)
              }, [])
            }, [])
            vm.ig_messages_incorrect = vm.ig_messages_incorrect.map(el => {
              return el.filter(sel => {
                return !['flex', 'imagemap', 'sticker'].includes(sel.type)
              }, [])
            }, [])
            vm.ig_messages_error = vm.ig_messages_error.map(el => {
              return el.filter(sel => {
                return !['flex', 'imagemap', 'sticker'].includes(sel.type)
              }, [])
            }, [])
            vm.ig_messages_duplicate = vm.ig_messages_duplicate.map(el => {
              return el.filter(sel => {
                return !['flex', 'imagemap', 'sticker'].includes(sel.type)
              }, [])
            }, [])

            vm.$set(vm.intent, 'fb_quick_reply', vm.intent.quick_reply)
            vm.$set(vm.intent, 'line_quick_reply', vm.intent.quick_reply)
            vm.$set(vm.intent, 'ig_quick_reply', vm.intent.quick_reply)
            vm.$set(vm.intent, 'whatsapp_quick_reply', vm.intent.quick_reply)
            vm.$set(vm.intent, 'google_quick_reply', vm.intent.quick_reply)
          }
        }
        vm.showMultipleChannel = payload.showMultipleChannel

        if (vm.showMultipleChannel) vm.tab = 'facebook'
        else vm.tab = 'all'
      } else if (payload && payload.hasOwnProperty('showMultipleChannel') && !payload.showMultipleChannel) {
        vm.showMultipleChannel = false
        vm.tab = 'all'
        vm.fb_messages = [[]]
        vm.fb_messages_correct = [[]]
        vm.fb_messages_incorrect = [[]]
        vm.fb_messages_error = [[]]
        vm.fb_messages_duplicate = [[]]
        vm.line_messages = [[]]
        vm.line_messages_correct = [[]]
        vm.line_messages_incorrect = [[]]
        vm.line_messages_error = [[]]
        vm.line_messages_duplicate = [[]]
        vm.whatsapp_messages = [[]]
        vm.whatsapp_messages_correct = [[]]
        vm.whatsapp_messages_incorrect = [[]]
        vm.whatsapp_messages_error = [[]]
        vm.whatsapp_messages_duplicate = [[]]
        vm.google_messages = [[]]
        vm.google_messages_correct = [[]]
        vm.google_messages_incorrect = [[]]
        vm.google_messages_error = [[]]
        vm.google_messages_duplicate = [[]]
        vm.ig_messages = [[]]
        vm.ig_messages_correct = [[]]
        vm.ig_messages_incorrect = [[]]
        vm.ig_messages_error = [[]]
        vm.ig_messages_duplicate = [[]]
      }
    },
    changeRemainingReply(value) {
      if (value) {
        this.remaining_reply = 0
      } else {
        this.remaining_reply = null
      }
    },
    formatQuestionData: function(text) {
      var questions = text && text !== '' ? text.split(',') : []
      var result = {
        normal: [],
        keyword: [],
        exactly: [],
        startwith: [],
        endwith: [],
        startandendwith: []
      }
      if (questions) {
        questions.forEach(function(question) {
          var pointer = null
          var keyword = null
          if (question.startsWith('startswith(') && question.endsWith(')')) {
            // startswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.startwith.push({ text: keyword })
          } else if (question.startsWith('endswith(') && question.endsWith(')')) {
            // endswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.endwith.push({ text: keyword })
          } else if (question.startsWith('startsendswith(') && question.endsWith(')')) {
            // startsendswith(...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.startandendwith.push({ text: keyword })
          } else if (question.startsWith('includes(') && question.endsWith(')')) {
            // includes(...&&...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.keyword.push({ text: keyword })
          } else if (question.startsWith('exacts(') && question.endsWith(')')) {
            // exacts(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.exactly.push({ text: keyword })
          } else {
            result.normal.push({ text: question })
          }
        })
      }
      return result
    },
    saveFilterPost(payload) {
      this.$set(this.intent, 'postidlist', payload.includes)
      this.$set(this.intent, 'exceptpostidlist', payload.excludes)
      this.$set(this.intent, 'post_keywords', payload.post_keywords)
      var includes = []
      var excludes = []
      var post_keywords = []
      if (payload.includes) {
        try {
          includes = JSON.parse(payload.includes)
        } catch (error) {
          includes = payload.includes.split(',')
        }
      }
      if (payload.excludes) {
        try {
          excludes = JSON.parse(payload.excludes)
        } catch (error) {
          excludes = payload.excludes.split(',')
        }
      }
      if (payload.post_keywords) {
        try {
          post_keywords = JSON.parse(payload.post_keywords)
        } catch (error) {}
      }
      this.postidlist = { includes, excludes, post_keywords }
    },
    changeOnlytime(e) {
      this.$forceUpdate()
    },
    toggleLineNotifyStatus: function() {
      this.intent.linenoti_status = !this.intent.linenoti_status
    },
    onShowAdvance: function() {
      this.showAdvanced = !this.showAdvanced
      // if (this.$store.getters.getPackage === 'premium') {
      // }
    },
    addGeneric: function() {
      this.generics.push({
        image_url: null,
        title: '',
        subtitle: '',
        buttons: [],

        enable: true
      })
    },
    sendToLivechat() {
      let vm = this
      if (vm.showMultipleChannel) {
        vm.intent.fb_val = JSON.stringify(vm.fb_messages).replace(/ /gim, ' ')
        vm.intent.line_val = JSON.stringify(vm.line_messages).replace(/ /gim, ' ')
        vm.intent.ig_val = JSON.stringify(vm.ig_messages).replace(/ /gim, ' ')
        vm.intent.whatsapp_val = JSON.stringify(vm.whatsapp_messages).replace(/ /gim, ' ')
        vm.intent.google_val = JSON.stringify(vm.google_messages).replace(/ /gim, ' ')
      }
      if (vm.showMultipleChannelFollowUp) {
        vm.intent.follow_up_fb_val = JSON.stringify(vm.fb_messages2).replace(/ /gim, ' ')
        vm.intent.follow_up_line_val = JSON.stringify(vm.line_messages2).replace(/ /gim, ' ')
        vm.intent.follow_up_ig_val = JSON.stringify(vm.ig_messages2).replace(/ /gim, ' ')
        vm.intent.follow_up_whatsapp_val = JSON.stringify(vm.whatsapp_messages2).replace(
          / /gim,
          ' '
        )
        vm.intent.follow_up_google_val = JSON.stringify(vm.google_messages2).replace(/ /gim, ' ')
      }

      var messages = vm.checkEmptyMessage(vm.messages)
      var a_val = JSON.stringify(messages)
      vm.$emit('sendToLivechat', { ...vm.intent, a_val })
    },
    saveIntent: function() {
      let vm = this
      if (vm.showMultipleChannelFollowUp) {
        //line
        if (vm.intent.follow_up_line_within_seconds) {
          vm.intent.follow_up_line_within_seconds.HH = vm.intent.follow_up_line_within_seconds.HH
            ? vm.intent.follow_up_line_within_seconds.HH
            : '00'
          vm.intent.follow_up_line_within_seconds.mm = vm.intent.follow_up_line_within_seconds.mm
            ? vm.intent.follow_up_line_within_seconds.mm
            : '00'
          vm.intent.follow_up_line_within_seconds.HH = `${vm.intent
            .follow_up_line_within_seconds_date *
            24 +
            parseInt(vm.intent.follow_up_line_within_seconds.HH)}`

          vm.intent.follow_up_line_within_seconds.mm = vm.intent.follow_up_line_within_seconds.mm
            ? vm.intent.follow_up_line_within_seconds.mm || 0
            : '00'
        } else {
          vm.intent.follow_up_line_within_seconds = {
            HH: `${vm.intent.follow_up_line_within_seconds_date * 24 || '00'}`,
            mm: '00'
          }
        }

        //fb
        if (vm.intent.follow_up_cart_fb_within_seconds) {
          vm.intent.follow_up_fb_within_seconds.HH = vm.intent.follow_up_fb_within_seconds.HH
            ? vm.intent.follow_up_fb_within_seconds.HH
            : '00'
          vm.intent.follow_up_fb_within_seconds.mm = vm.intent.follow_up_fb_within_seconds.mm
            ? vm.intent.follow_up_fb_within_seconds.mm
            : '00'
        }
        //ig
        if (vm.intent.follow_up_ig_within_seconds) {
          vm.intent.follow_up_ig_within_seconds.HH = vm.intent.follow_up_ig_within_seconds.HH
            ? vm.intent.follow_up_ig_within_seconds.HH
            : '00'
          vm.intent.follow_up_ig_within_seconds.mm = vm.intent.follow_up_ig_within_seconds.mm
            ? vm.intent.follow_up_ig_within_seconds.mm
            : '00'
        }
        //google
        if (vm.intent.follow_up_google_within_seconds) {
          vm.intent.follow_up_google_within_seconds.HH = vm.intent.follow_up_google_within_seconds
            .HH
            ? vm.intent.follow_up_google_within_seconds.HH
            : '00'
          vm.intent.follow_up_google_within_seconds.mm = vm.intent.follow_up_google_within_seconds
            .mm
            ? vm.intent.follow_up_google_within_seconds.mm
            : '00'
        }
        //whatsapp
        // vm.intent.follow_up_whatsapp_within_seconds.HH = vm.intent.follow_up_whatsapp_within_seconds.HH
        //   ? vm.intent.follow_up_whatsapp_within_seconds.HH
        //   : '00'
        // vm.intent.follow_up_whatsapp_within_seconds.mm = vm.intent.follow_up_whatsapp_within_seconds.mm
        //   ? vm.intent.follow_up_whatsapp_within_seconds.mm
        //   : '00'
      } else {
        if (vm.intent.follow_up_within_seconds) {
          vm.intent.follow_up_within_seconds.HH = vm.intent.follow_up_within_seconds.HH
            ? vm.intent.follow_up_within_seconds.HH
            : '00'
          vm.intent.follow_up_within_seconds.mm = vm.intent.follow_up_within_seconds.mm
            ? vm.intent.follow_up_within_seconds.mm
            : '00'
        }
      }

      // set verify_slip_setting

      let verify_slip_setting = {
        correct_a_val: null,
        incorrect_a_val: null,
        error_a_val: null,
        duplicate_a_val: null,
        correct_fb_val: null,
        incorrect_fb_val: null,
        error_fb_val: null,
        duplicate_fb_val: null,
        correct_line_val: null,
        incorrect_line_val: null,
        error_line_val: null,
        duplicate_line_val: null,
        correct_ig_val: null,
        incorrect_ig_val: null,
        error_ig_val: null,
        duplicate_ig_val: null,
        correct_google_val: null,
        incorrect_google_val: null,
        error_google_val: null,
        duplicate_google_val: null,
        correct_whatsapp_val: null,
        incorrect_whatsapp_val: null,
        error_whatsapp_val: null,
        duplicate_whatsapp_val: null
      }
      if (vm.isVerifySlip) {
        const getItem = arr => {
          let newArr = []
          if (arr && arr.length && arr[0] && arr[0][0] && arr[0][0].text && arr[0][0].type) {
            for (let i = 0; i < arr.length; i++) {
              const item = arr[i]
              newArr.push(...item)
            }
          }
          return newArr
        }
        if (!vm.showMultipleChannel) {
          Object.assign(verify_slip_setting, {
            correct_a_val: getItem(vm.messages_correct),
            incorrect_a_val: getItem(vm.messages_incorrect),
            error_a_val: getItem(vm.messages_error),
            duplicate_a_val: getItem(vm.messages_duplicate)
          })
        } else {
          const channels = vm.channelItem.map(item => item.name)

          if (channels.includes('line')) {
            Object.assign(verify_slip_setting, {
              correct_line_val: getItem(vm.line_messages_correct),
              incorrect_line_val: getItem(vm.line_messages_incorrect),
              error_line_val: getItem(vm.line_messages_error),
              duplicate_line_val: getItem(vm.line_messages_duplicate)
            })
          }

          if (channels.includes('facebook')) {
            Object.assign(verify_slip_setting, {
              correct_fb_val: getItem(vm.fb_messages_correct),
              incorrect_fb_val: getItem(vm.fb_messages_incorrect),
              error_fb_val: getItem(vm.fb_messages_error),
              duplicate_fb_val: getItem(vm.fb_messages_duplicate)
            })
          }

          if (channels.includes('instagram')) {
            Object.assign(verify_slip_setting, {
              correct_ig_val: getItem(vm.ig_messages_correct),
              incorrect_ig_val: getItem(vm.ig_messages_incorrect),
              error_ig_val: getItem(vm.ig_messages_error),
              duplicate_ig_val: getItem(vm.ig_messages_duplicate)
            })
          }
          if (channels.includes('google')) {
            Object.assign(verify_slip_setting, {
              correct_google_val: getItem(vm.google_messages_correct),
              incorrect_google_val: getItem(vm.google_messages_incorrect),
              error_google_val: getItem(vm.google_messages_error),
              duplicate_google_val: getItem(vm.google_messages_duplicate)
            })
          }
          if (channels.includes('whatsapp')) {
            Object.assign(verify_slip_setting, {
              correct_whatsapp_val: getItem(vm.whatsapp_messages_correct),
              incorrect_whatsapp_val: getItem(vm.whatsapp_messages_incorrect),
              error_whatsapp_val: getItem(vm.whatsapp_messages_error),
              duplicate_whatsapp_val: getItem(vm.whatsapp_messages_duplicate)
            })
          }
        }
      } else {
        verify_slip_setting = null
      }

      let data = {
        pageid: vm.selectedBot.pageid,
        q_type: vm.intent.q_type,
        q_val: vm.intent.q_val,
        a_type: 'json',
        a_val: vm.intent.a_val,
        ispriority: vm.intent.ispriority,
        quick_reply: vm.intent.quick_reply,
        postidlist: vm.intent.postidlist,
        exceptpostidlist: vm.intent.exceptpostidlist ? vm.intent.exceptpostidlist : '',
        post_keywords: vm.intent.post_keywords ? vm.intent.post_keywords : '',
        isShow: true,
        intentstatus: vm.intent.intentstatus ? vm.intent.intentstatus : false,
        onlytime:
          vm.intent.onlytime === null ? null : vm.intent.onlytime ? vm.intent.onlytime : false,
        intentgroup: vm.intent.intentgroup ? vm.intent.intentgroup : null,
        follow_up_status: vm.intent.follow_up_status ? vm.intent.follow_up_status : null,
        follow_up_quick_reply: vm.intent.follow_up_quick_reply,
        follow_up_within_seconds: vm.intent.follow_up_within_seconds
          ? (parseInt(vm.intent.follow_up_within_seconds.HH) * 60 +
              parseInt(
                vm.intent.follow_up_within_seconds.mm.substring(0, 1) == 0
                  ? vm.intent.follow_up_within_seconds.mm.substring(1)
                  : vm.intent.follow_up_within_seconds.mm
              )) *
            60
          : null,
        follow_up_line_within_seconds: vm.intent.follow_up_line_within_seconds
          ? (parseInt(vm.intent.follow_up_line_within_seconds.HH || '00') * 60 +
              parseInt(
                (vm.intent.follow_up_line_within_seconds.mm || '00').substring(0, 1) == 0
                  ? vm.intent.follow_up_line_within_seconds.mm.substring(1)
                  : vm.intent.follow_up_line_within_seconds.mm
              )) *
            60
          : null,
        follow_up_fb_within_seconds: vm.intent.follow_up_fb_within_seconds
          ? (parseInt(vm.intent.follow_up_fb_within_seconds.HH) * 60 +
              parseInt(
                vm.intent.follow_up_fb_within_seconds.mm.substring(0, 1) == 0
                  ? vm.intent.follow_up_fb_within_seconds.mm.substring(1)
                  : vm.intent.follow_up_fb_within_seconds.mm
              )) *
            60
          : null,
        follow_up_ig_within_seconds: vm.intent.follow_up_ig_within_seconds
          ? (parseInt(vm.intent.follow_up_ig_within_seconds.HH) * 60 +
              parseInt(
                vm.intent.follow_up_ig_within_seconds.mm.substring(0, 1) == 0
                  ? vm.intent.follow_up_ig_within_seconds.mm.substring(1)
                  : vm.intent.follow_up_ig_within_seconds.mm
              )) *
            60
          : null,
        follow_up_google_within_seconds: vm.intent.follow_up_google_within_seconds
          ? (parseInt(vm.intent.follow_up_google_within_seconds.HH) * 60 +
              parseInt(
                vm.intent.follow_up_google_within_seconds.mm.substring(0, 1) == 0
                  ? vm.intent.follow_up_google_within_seconds.mm.substring(1)
                  : vm.intent.follow_up_google_within_seconds.mm
              )) *
            60
          : null,
        //     follow_up_whatsapp_within_seconds:vm.intent.follow_up_whatsapp_within_seconds
        //  ? (parseInt(vm.intent.follow_up_whatsapp_within_seconds.HH) * 60 +
        //       parseInt(
        //         vm.intent.follow_up_whatsapp_within_seconds.mm.substring(0, 1) == 0
        //           ? vm.intent.follow_up_whatsapp_within_seconds.mm.substring(1)
        //           : vm.intent.follow_up_whatsapp_within_seconds.mm
        //       )) *
        //       60
        //     :null,
        follow_up_val: this.checkEmptyMessage(this.messages2)
          ? JSON.stringify(this.checkEmptyMessage(this.messages2))
          : null,
        follow_up_quick_reply: vm.intent.follow_up_quick_reply
          ? vm.intent.follow_up_quick_reply
          : null,
        follow_up_type: 'json',
        verify_slip_setting
      }

      if (this.eventSetting.event_name) {
        data.event_setting = this.eventSetting
      }

      if (this.isBeacon) {
        data.not_reply_within_seconds = vm.SecondToMinute(vm.not_reply_within_seconds)
        data.not_reply_within_times =
          vm.intent.not_reply_within_times === '' ? null : vm.intent.not_reply_within_times
        data.frequency_per_day =
          vm.intent.frequency_per_day === '' ? null : vm.intent.frequency_per_day
        data.campaign_name = vm.intent.campaign_name
        data.specific_beacon_ids =
          vm.intent.specific_beacon_ids === '' ? null : vm.intent.specific_beacon_ids
        data.status = vm.intent.status
      } else {
        data.intentname = vm.intent.intentname
      }
      if (this.showMultipleChannel) {
        data.fb_val = JSON.stringify(vm.fb_messages).replace(/ /gim, ' ')
        data.line_val = JSON.stringify(vm.line_messages).replace(/ /gim, ' ')
        data.ig_val = JSON.stringify(vm.ig_messages).replace(/ /gim, ' ')
        data.whatsapp_val = JSON.stringify(vm.whatsapp_messages).replace(/ /gim, ' ')
        data.fb_quick_reply = vm.intent.fb_quick_reply
        data.line_quick_reply = vm.intent.line_quick_reply
        data.ig_quick_reply = vm.intent.ig_quick_reply
        data.whatsapp_quick_reply = vm.intent.whatsapp_quick_reply
        data.google_val = JSON.stringify(vm.google_messages).replace(/ /gim, ' ')
        data.fb_quick_reply = vm.intent.fb_quick_reply
        data.line_quick_reply = vm.intent.line_quick_reply
        data.ig_quick_reply = vm.intent.ig_quick_reply
        data.google_quick_reply = vm.intent.google_quick_reply
      }
      if (this.showMultipleChannelFollowUp) {
        const filter_fb = vm.fb_messages2.map(item => {
          return item.filter(msg =>
            msg.type == 'text'
              ? msg.text !== ''
              : msg.type == 'button'
              ? msg.text !== ''
              : msg.image_url !== ''
          )
        })
        const filter_line = vm.line_messages2.map(item => {
          return item.filter(msg =>
            msg.type == 'text'
              ? msg.text !== ''
              : msg.type == 'button'
              ? msg.text !== ''
              : msg.image_url !== ''
          )
        })
        const filter_whatsapp = vm.whatsapp_messages2.map(item => {
          return item.filter(msg =>
            msg.type == 'text'
              ? msg.text !== ''
              : msg.type == 'button'
              ? msg.text !== ''
              : msg.image_url !== ''
          )
        })
        const filter_ig = vm.ig_messages2.map(item => {
          return item.filter(msg =>
            msg.type == 'text'
              ? msg.text !== ''
              : msg.type == 'button'
              ? msg.text !== ''
              : msg.image_url !== ''
          )
        })
        const filter_google = vm.google_messages2.map(item => {
          return item.filter(msg =>
            msg.type == 'text'
              ? msg.text !== ''
              : msg.type == 'button'
              ? msg.text !== ''
              : msg.image_url !== ''
          )
        })
        data.follow_up_fb_val = JSON.stringify(filter_fb).replace(/ /gim, ' ')
        data.follow_up_line_val = JSON.stringify(filter_line).replace(/ /gim, ' ')
        data.follow_up_whatsapp_val = JSON.stringify(filter_whatsapp).replace(/ /gim, ' ')
        data.follow_up_ig_val = JSON.stringify(filter_ig).replace(/ /gim, ' ')
        data.follow_up_google_val = JSON.stringify(filter_google).replace(/ /gim, ' ')
        data.follow_up_fb_quick_reply = vm.intent.follow_up_fb_quick_reply
        data.follow_up_line_quick_reply = vm.intent.follow_up_line_quick_reply
        data.follow_up_whatsapp_quick_reply = vm.intent.follow_up_whatsapp_quick_reply
        data.follow_up_ig_quick_reply = vm.intent.follow_up_ig_quick_reply
        data.follow_up_google_quick_reply = vm.intent.follow_up_google_quick_reply
      }

      if (vm.$store.getters.getPackage == 'premium') {
        data.context_in = vm.intent.context_in != null ? vm.intent.context_in : ''
        data.context_out = vm.intent.context_out != null ? vm.intent.context_out : ''
        data.follow_up_context_out =
          vm.intent.follow_up_context_out != null ? vm.intent.follow_up_context_out : ''
        data.userstatus = vm.intent.userstatus
        data.follow_up_userstatus = vm.intent.follow_up_userstatus
        data.usertags = vm.intent.usertags
        data.follow_up_usertags = vm.intent.follow_up_usertags
        data.linenoti_status = vm.intent.linenoti_status
        data.follow_up_linenoti_status = vm.intent.follow_up_linenoti_status
        try {
          var linenoti_spec_ids = vm.selectLinenotify.map(el => {
            return el.id
          })
          data.linenoti_spec_ids = linenoti_spec_ids.join(',')
        } catch (error) {
          data.linenoti_spec_ids = null
        }

        try {
          var follow_up_linenoti_spec_ids = vm.follow_up_selectLinenotify.map(el => {
            return el.id
          })
          data.follow_up_linenoti_spec_ids = follow_up_linenoti_spec_ids.join(',')
        } catch (error) {
          data.follow_up_linenoti_spec_ids = null
        }

        data.linenoti_text = vm.intent.linenoti_text
        data.follow_up_linenoti_text = vm.intent.follow_up_linenoti_text
        data.starttime = vm.startTimeFormatFN()
          ? vm.startTimeFormatFN() + dayjs().format('Z')
          : null
        data.endtime = vm.endTimeFormatFN() ? vm.endTimeFormatFN() + dayjs().format('Z') : null
        if (vm.isCommentToInbox) {
          data.remaining_reply = vm.remaining_reply == false ? null : vm.remaining_reply
          data.notreplysameperson = vm.notreplysameperson
        }
      } else {
        data.context_in = vm.cached_intent.context_in != null ? vm.cached_intent.context_in : ''
        data.context_out = vm.cached_intent.context_out != null ? vm.cached_intent.context_out : ''
        data.follow_up_context_out =
          vm.cached_intent.follow_up_context_out != null
            ? vm.cached_intent.follow_up_context_out
            : ''

        data.userstatus = vm.cached_intent.userstatus
        data.follow_up_userstatus = vm.cached_intent.follow_up_userstatus
        data.usertags = vm.cached_intent.usertags
        data.follow_up_usertags = vm.cached_intent.follow_up_usertags
        data.linenoti_status = vm.cached_intent.linenoti_status
        data.follow_up_linenoti_status = vm.cached_intent.follow_up_linenoti_status
        data.linenoti_spec_ids = vm.cached_intent.linenoti_spec_ids
        data.follow_up_linenoti_spec_ids = vm.cached_intent.follow_up_linenoti_spec_ids
        data.linenoti_text = vm.cached_intent.linenoti_text
        data.follow_up_linenoti_text = vm.cached_intent.follow_up_linenoti_text
        data.starttime = vm.cached_intent.starttime ? vm.cached_intent.starttime : null
        data.endtime = vm.cached_intent.endtime ? vm.cached_intent.endtime : null
        if (vm.isCommentToInbox) {
          data.remaining_reply = null
          data.notreplysameperson = false
        }
      }
      if (vm.isWelcome) {
        var welcome_answer = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
        data.a_val = JSON.stringify(welcome_answer)
      } else {
        if (vm.isCommentToInbox && !vm.isLiveStream) {
          var message = []
          if (vm.messages) {
            message = vm.checkEmptyReplyMessage(vm.messages)
          }

          if (message.length === 0) {
            message.push([
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                is_like_comment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: ''
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ])
          }
          data.a_val = JSON.stringify(message).replace(/ /gim, ' ')
          data.context_in = 'comment'
          data.a_type = 'json'
        } else if (vm.isLiveStream) {
          var message = []
          if (vm.messages) {
            message = vm.checkEmptyReplyMessage(vm.messages)
          }

          if (message.length === 0) {
            message.push([
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                is_like_comment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: ''
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ])
          }
          data.a_val = JSON.stringify(message).replace(/ /gim, ' ')
          data.context_in = 'facebooklive'
          data.a_type = 'json'
        } else if (data.a_type === 'json') {
          var messages = vm.checkEmptyMessage(vm.messages)
          data.a_val = JSON.stringify(messages)
        }
      }
      vm.$validator
        .validateAll(vm.intent.id)
        .then(result => {
          if (!result) {
            vm.goToErrorInput()
            // do stuff if not valid.
            // console.log(this.$validator.errors.items)
            return false
          }

          if (!vm.intent.id) {
            vm.$store.dispatch('loading')
            if (!this.isBeacon) {
              if (vm.intent.onlytime === null) {
                data.starttime = null
                data.endtime = null
                Object.assign(data, { time_setting: vm.intent.time_setting })
              }
              api.addIntent(data, function(error, response) {
                if (error) {
                  if (response.result === 'DUPLICATE_INTENT_NAME') {
                    vm.$swal({
                      title: vm.$t('Error'),
                      type: 'error',
                      text: vm.$t('duplicate_conversation_name'),
                      confirmButtonText: vm.$t('Confirm')
                    })
                  }
                  console.error(error)
                  vm.$store.dispatch('loading')
                  return
                }
                data.id = response.id
                vm.$emit('input', data)
                vm.$emit('saveIntent', data)
                vm.$emit('close', null)
                vm.$store.dispatch('loading')
                vm.intent = cloneDeep(vm.intentTemplate())
                vm.cached_intent = Object.assign({}, vm.intent)
              })
            } else {
              api.addIntentBecon(data, function(error, response) {
                if (error) {
                  if (response.result === 'DUPLICATE_INTENT_NAME') {
                    vm.$swal({
                      title: vm.$t('Error'),
                      type: 'error',
                      text: vm.$t('duplicate_conversation_name'),
                      confirmButtonText: vm.$t('Confirm')
                    })
                  }
                  console.error(error)
                  vm.$store.dispatch('loading')
                  return
                }
                vm.$emit('input', response)
                vm.$emit('saveIntent', response)
                vm.$emit('close', null)
                vm.$store.dispatch('loading')
                vm.intent = cloneDeep(vm.intentTemplate())
                vm.cached_intent = Object.assign({}, vm.intent)
              })
            }
          } else {
            data['id'] = vm.intent.id
            vm.$store.dispatch('loading')
            if (!this.isBeacon) {
              if (this.noUpdatedAt) {
                data['noUpdatedAt'] = this.noUpdatedAt
              }
              if (vm.intent.onlytime === null) {
                data.starttime = null
                data.endtime = null
                Object.assign(data, { time_setting: vm.intent.time_setting })
              }

              api.editIntent(data, function(error, response) {
                if (error) {
                  if (response.result === 'DUPLICATE_INTENT_NAME') {
                    vm.$swal({
                      title: vm.$t('Error'),
                      type: 'error',
                      text: vm.$t('duplicate_conversation_name'),
                      confirmButtonText: vm.$t('Confirm')
                    })
                  }
                  console.error(error)
                  vm.$store.dispatch('loading')
                  return
                }
                data.created_at = vm.intent.created_at
                data.created_by = vm.intent.created_by
                vm.$emit('input', data)
                vm.$emit('saveIntent', data)
                vm.cached_intent = Object.assign({}, vm.intent)

                vm.$store.dispatch('loading')
              })
            } else {
              api.editIntentBecon(data, function(error, response) {
                if (error) {
                  console.error(error)
                  vm.$store.dispatch('loading')
                  return
                }
                vm.$emit('input', data)
                vm.$emit('saveIntent', data)
                vm.cached_intent = Object.assign({}, vm.intent)

                vm.$store.dispatch('loading')
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    MinuteToSecond(minute) {
      var m = null
      if (typeof minute === 'string') {
        m = parseFloat(minute)
      }
      return Math.floor(m / 60) ? JSON.stringify(Math.floor(m / 60)) : null
    },

    SecondToMinute(second) {
      var s = null
      if (typeof second === 'string') {
        s = parseFloat(second)
      }
      return Math.floor(s * 60) ? JSON.stringify(Math.floor(s * 60)) : null
    },
    cancelEdit: function() {
      var vm = this
      vm.intent = Object.assign({}, vm.cached_intent)
      vm.$emit('close', null)
    },
    closeShowSelectBeacon() {
      this.showSelectBeacon = false
    },
    checkTag(obj) {
      this.errorQuestionTag = []
      if (obj.tag.text == '') {
      } else if (obj.tag.isDuplicate) {
        // this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorQuestionTag.push('duplicate')
        obj.error()
      } else obj.addTag()

      // if (obj.tag.text.includes(',')) alert('Letter "," is forbidden');
    },
    checkQuickReply(type, obj) {
      const vm = this
      vm.errorTag[type] = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 20) {
        vm.errorTag[type].push('overmaxlength')
        obj.error()
      } else if (
        obj.type == 'add' &&
        ((type == 'replies' && vm.replies.length >= 10) ||
          (type == 'facebook' && vm.fb_replies.length >= 10) ||
          (type == 'line' && vm.line_replies.length >= 10) ||
          (type == 'whatsapp' && vm.whatsapp_replies.length >= 10) ||
          (type == 'instagram' && vm.ig_replies.length >= 10) ||
          (type == 'google' && vm.google_replies.length >= 10))
      ) {
        vm.errorTag[type].push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        vm.errorTag[type].push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    checkUserTags(obj) {
      this.errorUserTags = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 25) {
        this.errorUserTags.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorUserTags.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onDeleteGeneric(index) {
      this.generics.splice(index, 1)
    },
    onMove: function(index, direction) {
      var vm = this
      if (direction === 'left') {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction === 'right') {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
    },
    onChangeReplyComment: function() {
      if (this.isReplyComment) {
        this.intent.context_in = 'comment'
        this.replyComment = ''
      } else {
        this.intent.context_in = ''
        this.replyComment = ''
      }
    },
    onChangeIntentStatus: function() {
      var vm = this
      let intentstatus = null
      if (vm.isBeacon) {
        intentstatus = vm.intent.status ? vm.intent.status : false
        vm.$set(vm.intent, 'status', !intentstatus)
      } else {
        intentstatus = vm.intent.intentstatus ? vm.intent.intentstatus : false
        vm.$set(vm.intent, 'intentstatus', !intentstatus)
      }
    },
    onChangeIntentOnlyTime: function() {
      let onlytime =
        this.intent.onlytime === null ? null : this.intent.onlytime ? this.intent.onlytime : false

      this.$set(this.intent, 'onlytime', !onlytime)
    },
    addIntentPrefill: function(prefill) {
      var vm = this
      let cursorPosition = this.$refs.replyComment.$el.selectionStart
      vm.replyComment = [
        vm.replyComment.slice(0, cursorPosition),
        '{' + prefill + '}',
        vm.replyComment.slice(cursorPosition)
      ].join('')
    },
    addEmoji: function(emoji) {
      var vm = this
      let cursorPosition = this.$refs.answer[this.currentIndex].$el.selectionStart
      vm.replyComment = [
        vm.replyComment.slice(0, cursorPosition),
        emoji.native,
        vm.replyComment.slice(cursorPosition)
      ].join('')
      vm.showEmoji = false
    },
    changeIntentType: function(type) {
      var vm = this
      if (type == 'text' && (vm.intent.a_type == '' || vm.intent.a_type == null)) {
        this.text = this.intent.a_val
      }

      if (vm.intent.a_type == 'text') {
        this.text = this.intent.a_val
      }

      if (type == 'text') {
        this.intent.a_val = this.text
      }
      vm.intent.a_type = type
    },
    addReplies: function(type, newTags) {
      const vm = this
      if (type == 'facebook') vm.fb_replies = newTags
      else if (type == 'line') vm.line_replies = newTags
      else if (type == 'whatsapp') vm.whatsapp_replies = newTags
      else if (type == 'instagram') vm.ig_replies = newTags
      else if (type == 'google') vm.google_replies = newTags
      else vm.replies = newTags
    },
    addUserTags: function(newTags) {
      this.usertags = newTags
    },
    onInputChange(text) {
      if (text === '' || text === undefined) {
        return
      }

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.options[0].data
        .filter(item => {
          return item.toLowerCase().indexOf(text.toLowerCase()) > -1
        })
        .slice(0, this.limit)

      this.filteredOptions = [
        {
          data: filteredData
        }
      ]
    },
    onFailLoad: function() {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    insertEventPurchaseValuePrefill(value) {
      this.eventSetting = {
        ...this.eventSetting,
        value: `{${value}}`
      }
    },
    onEventNameChanged(value) {
      this.eventSetting = {
        ...this.eventSetting,
        event_name: value
      }
    },
    checkOverTime() {
      const today = dayjs().format('YYYY-MM-DD')
      const startTime = this.startTimeInput || '00:00'
      const startDate = this.startDate
        ? dayjs(`${this.startDate} ${startTime}`)
        : dayjs(`${today} ${startTime}`)
      const endTime =
        this.endTimeInput && this.endTimeInput !== '24:00' ? this.endTimeInput : '23:59:59'
      const endDate = this.endDate
        ? dayjs(`${this.endDate} ${endTime}`)
        : dayjs(`${today} ${endTime}`)

      return startDate && endDate && startDate > endDate
    },
    handleStartdate() {
      const isOverTime = this.checkOverTime()
      if (isOverTime) {
        this.endDate = null
        this.endTime = null
      }
      this.openStartDate = false
    },
    handleEndDate() {
      const isOverTime = this.checkOverTime()
      if (isOverTime) {
        this.startDate = null
        this.startTime = null
      }
      this.openEndDate = false
    },
    handleStartTime() {
      const isOverTime = this.checkOverTime()
      if (isOverTime) {
        this.endTime = null
      }
      this.openStartDate = false
    },
    handleEndTime() {
      const isOverTime = this.checkOverTime()
      if (isOverTime) {
        this.startTime = null
      }
      this.openEndDate = false
    },
    onChangeChannel(tab) {
      if (tab.disabled) return
      this.tab = tab.name
    }
  },
  watch: {
    showPreview: function(newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    'intent.context_in': function(newVal, oldVal) {
      if (newVal == 'comment') {
        this.isReplyComment = true
      } else {
        this.isReplyComment = false
      }
    },
    value: function(newVal, oldVal) {
      var vm = this
      vm.intent = Object.assign({}, vm.value)
      vm.cached_intent = Object.assign({}, vm.value)
      if (vm.intent.starttime) {
        var startTime = dayjs(this.formatTime(vm.intent.starttime))
        vm.startDate = startTime.format('YYYY-MM-DD')
        vm.startTime = {
          HH: startTime.format('HH'),
          mm: startTime.format('mm')
        }
      }
      if (vm.intent.endtime) {
        var endTime = dayjs(this.formatTime(vm.intent.endtime))
        vm.endDate = endTime.format('YYYY-MM-DD')
        vm.endTime = {
          HH: endTime.format('HH'),
          mm: endTime.format('mm')
        }
      }

      if (vm.value.a_type == 'text') {
      }

      if (vm.value.a_type == 'template') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          vm.generics = JSON.parse(vm.value.a_val)
        } else {
          vm.generics = []
        }
      }

      if (vm.value.a_type == 'json') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          vm.messages = JSON.parse(vm.value.a_val)
        } else {
          vm.messages = []
        }
      }

      if (vm.value.context_in == 'comment') {
        vm.replyComment = vm.value.a_val
      }
    },
    excludedIntentName: function() {
      var vm = this
      vm.intents = vm.excludedIntentName.split(',')
      vm.intents.push('comment')
      vm.intents.push('{default}')
      vm.intents.push('{welcome}')
      vm.intents.push('{default_comment_to_inbox}')

      if (vm.type == 'edit' && vm.excludedIntentName && vm.excludedIntentName != '' && vm.intent) {
        var result = []
        var names = vm.intents
        $.each(names, function(index, name) {
          if (name == vm.intent.intentname) {
            names.splice(index, 1)
            return false
          }
        })

        vm.excludedName = names.join(',').replace('|', '//#or//')
      } else {
        vm.excludedName = vm.intents.join(',').replace('|', '//#or//')
      }
    }
  }
}
</script>
<style lang="scss" scope>
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0;
}
.v-messages {
  min-height: 0;
}
.v-input {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  font-size: 16px;
  text-align: left;
  // justify-content: end;
}

.v-input.v-input--is-disabled {
  > .v-input__control {
    > .v-input__slot {
      background-color: #eee !important;
    }
  }
}

.form-control input[type='text']:disabled {
  color: rgba(0, 0, 0, 0.38);
}
</style>

<style lang="scss">
.v-select__slot {
  height: 100% !important;
}

.tab-channel {
  position: relative;
  border: 1px solid #eee;
  border-width: 1px 0px 1px 1px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  padding: 4px 8px;
  cursor: pointer;

  .lock {
    position: absolute;
    right: -3.5px;
    top: -4px;

    .v-chip {
      &.v-chip--small {
        height: 12px !important;
      }
      .v-chip__content {
        padding: 2px 4px !important;
        text-align: center;

        i {
          font-size: 10px !important;
        }
      }
    }
  }

  // font-size: 11px;

  &.disabled {
    cursor: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/intent-manage.vue